var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _g, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 473,
    viewBox: "0 0 650 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.8848,
    y: 258.857,
    width: 551.049,
    height: 214.143,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 196.462,
    y: 133.981,
    width: 402.315,
    height: 184.875,
    fill: "url(#pattern1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 222.308,
    y: 204.711,
    width: 210.667,
    height: 126.827,
    fill: "url(#pattern2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 460.773,
    y: 356.905,
    width: 74.1235,
    height: 74.1451,
    fill: "url(#pattern3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M406.174 449.362L407.658 450.215C408.261 450.526 408.93 450.687 409.608 450.687C410.287 450.687 410.956 450.526 411.559 450.215L480.237 410.561C480.469 410.478 480.669 410.325 480.811 410.123C480.953 409.921 481.029 409.68 481.029 409.433C481.029 409.187 480.953 408.946 480.811 408.744C480.669 408.542 480.469 408.389 480.237 408.305L479.932 408.123L477.9 407.005C477.668 406.921 477.468 406.768 477.326 406.566C477.184 406.364 477.108 406.123 477.108 405.877C477.108 405.63 477.184 405.389 477.326 405.187C477.468 404.985 477.668 404.832 477.9 404.749L478.611 404.322C479.218 404.021 479.885 403.864 480.562 403.864C481.239 403.864 481.906 404.021 482.513 404.322C483.12 404.632 483.792 404.794 484.473 404.794C485.155 404.794 485.827 404.632 486.434 404.322L493.932 399.993C494.164 399.909 494.364 399.756 494.506 399.554C494.648 399.352 494.724 399.111 494.724 398.865C494.724 398.618 494.648 398.377 494.506 398.175C494.364 397.973 494.164 397.82 493.932 397.736L491.047 396.09L592.641 337.453L574.009 289.527L491.047 278.795L273.431 404.505L271.704 405.501L257.48 413.752L260.772 415.663L274.995 407.411L373.319 464.178L386.14 456.78L391.281 459.687C391.887 459.988 392.554 460.144 393.231 460.144C393.908 460.144 394.576 459.988 395.182 459.687L403.452 454.91C403.684 454.827 403.884 454.673 404.026 454.472C404.168 454.27 404.244 454.029 404.244 453.782C404.244 453.536 404.168 453.295 404.026 453.093C403.884 452.891 403.684 452.738 403.452 452.654L401.948 451.801C401.716 451.717 401.516 451.564 401.374 451.362C401.232 451.16 401.156 450.919 401.156 450.673C401.156 450.426 401.232 450.185 401.374 449.983C401.516 449.782 401.716 449.628 401.948 449.545L402.375 449.301C402.97 449.017 403.623 448.874 404.282 448.885C404.941 448.895 405.589 449.059 406.174 449.362Z",
    fill: "#0F1C75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M367.972 325.543L373.255 336.742C374.192 338.783 375.778 340.455 377.766 341.498C380.45 342.875 383.42 343.604 386.437 343.625C389.454 343.646 392.434 342.959 395.138 341.62L367.972 325.543Z",
    fill: "#111E72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M364.377 324.467L329.977 326.702C330.526 332.8 339.365 342.129 346.232 344.344L364.377 324.467Z",
    fill: "url(#paint0_linear_1_781)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M366.083 324.975L348.873 336.886C352.47 343.288 363.828 347.76 371.691 347.191L366.083 324.975Z",
    fill: "url(#paint1_linear_1_781)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M367.972 324.791L372.991 335.42C374.178 338.042 376.29 340.134 378.924 341.294C381.499 342.42 384.29 342.965 387.099 342.891C389.908 342.818 392.667 342.127 395.179 340.867L367.972 324.791Z",
    fill: "url(#paint2_linear_1_781)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M369.337 324.627L397.174 332.107C403.27 333.712 407.333 331.964 407.659 328.428L369.337 324.627Z",
    fill: "#111E72"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M369.337 324.019L397.174 331.478C403.27 333.083 407.333 331.356 407.659 327.799L369.337 324.019Z",
    fill: "url(#paint3_linear_1_781)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M370.128 329.364V330.258L369.397 329.08L370.128 329.364Z",
    fill: "#2D36AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M376.732 325.991V326.865L376.183 326.743C376.183 326.743 376 326.072 376.02 326.072L376.732 325.991Z",
    fill: "#2D36AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M509.882 319.69L500.474 314.263L491.758 319.283L403.228 370.421L387.217 379.669L397.681 385.766L402.11 388.327L405.951 390.542C406.141 390.633 406.349 390.68 406.56 390.68C406.771 390.68 406.979 390.633 407.17 390.542L418.65 383.916C418.72 383.887 418.78 383.837 418.821 383.774C418.863 383.711 418.886 383.637 418.886 383.561C418.886 383.485 418.863 383.411 418.821 383.347C418.78 383.284 418.72 383.235 418.65 383.205L414.81 380.99L418.142 379.059L421.982 381.274C422.17 381.374 422.379 381.426 422.592 381.426C422.804 381.426 423.014 381.374 423.201 381.274L510.573 330.848C510.645 330.823 510.707 330.777 510.751 330.715C510.795 330.653 510.818 330.579 510.818 330.503C510.818 330.427 510.795 330.353 510.751 330.291C510.707 330.229 510.645 330.182 510.573 330.157L506.733 327.942L509.719 326.214C510.326 326.525 510.999 326.686 511.68 326.686C512.362 326.686 513.034 326.525 513.641 326.214L523.069 320.767C524.166 320.137 524.166 319.121 523.069 318.511L520.59 317.068C519.983 316.758 519.311 316.596 518.629 316.596C517.948 316.596 517.276 316.758 516.669 317.068L512.056 319.731C511.72 319.909 511.344 320 510.964 319.993C510.583 319.985 510.211 319.881 509.882 319.69Z",
    fill: "#192584"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M510.732 328.043V330.462L507.745 329.263L510.732 328.043Z",
    fill: "#192584"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M523.798 317.21V319.608L521.726 318.206L523.798 317.21Z",
    fill: "#192584"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M509.882 317.271L500.474 311.844L491.758 316.885L403.228 368.002L387.217 377.27L397.681 383.368L402.11 385.928L405.951 388.144C406.138 388.244 406.348 388.296 406.56 388.296C406.773 388.296 406.982 388.244 407.17 388.144L418.65 381.518C418.72 381.488 418.78 381.439 418.821 381.376C418.863 381.312 418.886 381.238 418.886 381.162C418.886 381.086 418.863 381.012 418.821 380.949C418.78 380.886 418.72 380.836 418.65 380.807L414.81 378.591L418.142 376.66L421.982 378.876C422.17 378.975 422.379 379.028 422.592 379.028C422.804 379.028 423.014 378.975 423.201 378.876L510.573 328.47C510.918 328.267 510.918 327.962 510.573 327.759L506.651 325.543L509.638 323.816C510.245 324.126 510.917 324.288 511.599 324.288C512.281 324.288 512.953 324.126 513.56 323.816L522.988 318.369C524.085 317.739 524.085 316.743 522.988 316.113L520.509 314.67C519.902 314.359 519.23 314.197 518.548 314.197C517.866 314.197 517.194 314.359 516.587 314.67L511.975 317.332C511.648 317.494 511.286 317.573 510.921 317.562C510.556 317.551 510.199 317.451 509.882 317.271Z",
    fill: "#2D36AD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M399.162 384.181L520.507 314.609L516.382 312.19L397.659 383.307L399.162 384.181Z",
    fill: "#192584"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M418.872 381.111V383.55L415.763 382.494L418.872 381.111Z",
    fill: "#192584"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M418.732 376.966L421.963 378.815C422.15 378.915 422.36 378.967 422.572 378.967C422.785 378.967 422.994 378.915 423.182 378.815L510.553 328.41C510.899 328.206 510.899 327.902 510.553 327.698L507.323 325.828L418.732 376.966Z",
    fill: "url(#paint4_linear_1_781)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M407.15 388.083L418.63 381.457C418.7 381.428 418.76 381.378 418.802 381.315C418.843 381.251 418.866 381.177 418.866 381.101C418.866 381.025 418.843 380.951 418.802 380.888C418.76 380.825 418.7 380.775 418.63 380.746L415.399 378.896L402.7 386.213L405.931 388.083C406.119 388.183 406.328 388.235 406.54 388.235C406.753 388.235 406.962 388.183 407.15 388.083Z",
    fill: "url(#paint5_linear_1_781)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M590.831 257.881L374.8 382.655L363.828 368.956L286.392 324.221L275.42 325.258L491.451 200.483L509.047 195.626L571.162 204.487L586.503 240.361L590.831 257.881Z",
    fill: "#242993"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M361.696 367.717L585.651 238.39L571.164 204.488L512.463 196.114L288.507 325.462L361.696 367.717Z",
    fill: "#242993"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M363.829 368.957L586.504 240.362L590.832 257.882L374.801 382.656L363.829 368.957Z",
    fill: "url(#paint6_linear_1_781)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M286.392 324.221L509.047 195.626L491.451 200.483L275.42 325.258L286.392 324.221Z",
    fill: "url(#paint7_linear_1_781)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M361.696 364.607L585.651 235.28L571.164 201.379L512.463 193.005L288.507 322.352L361.696 364.607Z",
    fill: "url(#paint8_linear_1_781)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M330.08 346.355L573.135 205.992L571.164 201.378L565.454 200.565L321.546 341.416L330.08 346.355Z",
    fill: "url(#paint9_linear_1_781)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M565.454 201.988L571.164 202.801L572.647 206.256L573.135 205.992L571.164 201.378L565.454 200.565L321.546 341.416L322.785 342.128L565.454 201.988Z",
    fill: "#242993"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M361.696 364.608V367.717L288.507 325.462V322.352L361.696 364.608Z",
    fill: "#192584"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M361.696 364.608V367.717L288.507 325.462V322.352L361.696 364.608Z",
    fill: "#404FCE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M361.695 364.606L585.65 235.279V238.389L361.695 367.716V364.606Z",
    fill: "url(#paint10_linear_1_781)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M374.8 382.656V422.005L275.42 364.607V325.258L286.392 324.222L363.828 368.957L374.8 382.656Z",
    fill: "#2D36AD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M372.73 383.835V423.204L273.35 365.806V326.437L284.322 325.421L361.757 370.136L372.73 383.835Z",
    fill: "#2D36AD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M374.8 382.656V396.985L590.831 272.211V257.882L374.8 382.656Z",
    fill: "url(#paint11_linear_1_781)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M372.727 423.204L374.8 422.005V382.656L372.727 383.835V423.204Z",
    fill: "#5F74EA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M374.802 382.656L363.83 368.957L361.758 370.135L372.73 383.834L374.802 382.656Z",
    fill: "#5F74EA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M373.927 341.478C362.967 341.697 352.132 339.109 342.453 333.958C333.818 328.978 329.124 322.312 329.246 315.198C329.368 308.084 334.041 301.783 342.453 296.905C359.806 286.885 388.029 286.885 405.442 296.905C413.793 301.722 418.466 308.165 418.649 315.035C418.832 321.905 414.139 328.897 405.462 333.917C395.77 339.092 384.912 341.695 373.927 341.478ZM373.927 290.564C363.172 290.353 352.542 292.893 343.043 297.942C335.017 302.576 330.526 308.714 330.425 315.218C330.323 321.722 334.793 328.185 343.043 332.962C360.07 342.799 387.744 342.799 404.833 332.962C413.143 328.165 417.613 321.824 417.451 315.096C417.288 308.369 412.798 302.556 404.833 297.942C395.321 292.887 384.676 290.347 373.907 290.564H373.927Z",
    fill: "#0B196D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M415.357 307.007V302.109L408.794 294.304L401.236 290.036L389.837 285.666L378.682 284.203H365.353L352.674 286.926L344.221 290.422L337.272 295.382L331.481 304.792V308.735C330.382 310.984 329.852 313.469 329.937 315.971H332.944C332.886 314.034 333.217 312.106 333.919 310.3L361.187 293.024L363.544 292.617L382.38 294.772L399.692 299.853L412.818 308.146C414.406 310.856 415.069 314.009 414.707 317.129H417.694C418.084 313.588 417.26 310.019 415.357 307.007Z",
    fill: "url(#paint12_linear_1_781)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M437.728 314.406L368.684 274.549L370.228 273.654L439.272 313.511L437.728 314.406Z",
    fill: "#5F74EA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M436.571 315.075L367.527 275.198L368.685 274.548L437.729 314.405L436.571 315.075Z",
    fill: "#3C53C9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M435.027 315.97L365.983 276.092L367.527 275.198L436.571 315.075L435.027 315.97Z",
    fill: "#5F74EA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M433.89 316.642L364.846 276.764L365.984 276.094L435.028 315.971L433.89 316.642Z",
    fill: "#3C53C9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M432.322 317.536L363.299 277.658L364.843 276.764L433.887 316.641L432.322 317.536Z",
    fill: "#5F74EA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M431.185 318.186L362.141 278.309L363.299 277.659L432.322 317.536L431.185 318.186Z",
    fill: "#3C53C9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M429.641 319.08L360.597 279.223L362.141 278.309L431.185 318.186L429.641 319.08Z",
    fill: "#5F74EA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M428.484 319.751L359.46 279.874L360.598 279.223L429.642 319.08L428.484 319.751Z",
    fill: "#3C53C9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M426.939 320.645L357.895 280.767L359.46 279.873L428.483 319.75L426.939 320.645Z",
    fill: "#5F74EA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M425.801 321.294L356.757 281.437L357.895 280.767L426.939 320.644L425.801 321.294Z",
    fill: "#3C53C9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M424.258 322.189L355.214 282.332L356.759 281.438L425.802 321.295L424.258 322.189Z",
    fill: "#5F74EA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M423.101 322.861L354.057 282.984L355.215 282.333L424.259 322.191L423.101 322.861Z",
    fill: "#3C53C9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M421.554 323.755L352.51 283.877L354.054 282.983L423.098 322.86L421.554 323.755Z",
    fill: "#5F74EA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M420.397 324.404L351.373 284.547L352.511 283.876L421.555 323.754L420.397 324.404Z",
    fill: "#3C53C9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M418.853 325.299L349.829 285.442L351.374 284.547L420.397 324.404L418.853 325.299Z",
    fill: "#5F74EA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M417.713 325.97L348.669 286.092L349.827 285.442L418.851 325.299L417.713 325.97Z",
    fill: "#3C53C9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M416.168 326.865L347.124 286.987L348.668 286.093L417.712 325.971L416.168 326.865Z",
    fill: "#5F74EA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M415.01 327.536L345.966 287.659L347.124 286.988L416.168 326.865L415.01 327.536Z",
    fill: "#3C53C9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M413.467 328.43L344.423 288.552L345.968 287.658L415.011 327.535L413.467 328.43Z",
    fill: "#5F74EA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M412.329 329.08L343.285 289.223L344.423 288.552L413.467 328.429L412.329 329.08Z",
    fill: "#3C53C9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M410.766 329.975L341.742 290.098L343.287 289.224L412.33 329.081L410.766 329.975Z",
    fill: "#5F74EA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M409.628 330.644L340.584 290.766L341.742 290.096L410.766 329.973L409.628 330.644Z",
    fill: "#3C53C9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M408.084 331.539L339.04 291.661L340.585 290.767L409.628 330.644L408.084 331.539Z",
    fill: "#5F74EA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M406.923 332.19L337.9 292.333L339.038 291.662L408.082 331.54L406.923 332.19Z",
    fill: "#3C53C9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M405.381 333.084L336.337 293.227L337.902 292.332L406.925 332.189L405.381 333.084Z",
    fill: "#5F74EA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M404.243 333.754L335.199 293.877L336.337 293.227L405.381 333.084L404.243 333.754Z",
    fill: "#3C53C9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M402.7 334.649L333.656 294.772L335.2 293.877L404.244 333.755L402.7 334.649Z",
    fill: "#5F74EA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M401.538 335.32L332.494 295.442L333.652 294.772L402.696 334.649L401.538 335.32Z",
    fill: "#3C53C9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M399.995 336.194L330.951 296.337L332.496 295.442L401.539 335.32L399.995 336.194Z",
    fill: "#5F74EA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M398.838 336.865L329.814 296.987L330.952 296.337L399.996 336.194L398.838 336.865Z",
    fill: "#3C53C9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M397.293 337.758L328.269 297.881L329.814 296.986L398.837 336.864L397.293 337.758Z",
    fill: "#5F74EA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M396.156 338.429L327.112 298.552L328.27 297.881L397.294 337.758L396.156 338.429Z",
    fill: "#3C53C9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M394.612 339.324L325.568 299.446L327.113 298.552L396.156 338.429L394.612 339.324Z",
    fill: "#5F74EA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M393.455 339.974L324.411 300.117L325.569 299.447L394.613 339.324L393.455 339.974Z",
    fill: "#3C53C9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M391.91 340.868L322.866 301.011L324.411 300.117L393.454 339.974L391.91 340.868Z",
    fill: "#5F74EA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M390.77 341.539L321.726 301.662L322.864 301.011L391.908 340.868L390.77 341.539Z",
    fill: "#3C53C9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M389.207 342.433L320.183 302.555L321.728 301.661L390.771 341.538L389.207 342.433Z",
    fill: "#5F74EA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M388.069 343.084L319.025 303.227L320.183 302.556L389.207 342.433L388.069 343.084Z",
    fill: "#3C53C9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M386.524 343.977L317.48 304.12L319.025 303.226L388.068 343.083L386.524 343.977Z",
    fill: "#5F74EA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M385.368 344.649L316.344 304.771L317.482 304.121L386.526 343.978L385.368 344.649Z",
    fill: "#3C53C9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M383.821 345.544L314.777 305.666L316.342 304.772L385.365 344.649L383.821 345.544Z",
    fill: "#5F74EA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M382.684 346.194L313.64 306.337L314.778 305.666L383.822 345.543L382.684 346.194Z",
    fill: "#3C53C9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M381.12 347.087L312.096 307.23L313.641 306.335L382.684 346.193L381.12 347.087Z",
    fill: "#5F74EA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M379.982 347.758L310.938 307.88L312.096 307.23L381.12 347.087L379.982 347.758Z",
    fill: "#3C53C9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M378.438 348.653L309.395 308.776L310.939 307.881L379.982 347.759L378.438 348.653Z",
    fill: "#5F74EA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M377.28 349.323L308.256 309.445L309.394 308.775L378.438 348.652L377.28 349.323Z",
    fill: "#3C53C9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M375.735 350.217L306.711 310.34L308.256 309.446L377.279 349.323L375.735 350.217Z",
    fill: "#5F74EA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M374.597 350.868L305.553 310.99L306.711 310.34L375.735 350.217L374.597 350.868Z",
    fill: "#3C53C9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M373.052 351.763L304.008 311.886L305.553 310.991L374.596 350.869L373.052 351.763Z",
    fill: "#5F74EA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M371.895 352.433L302.851 312.556L304.009 311.885L373.053 351.763L371.895 352.433Z",
    fill: "#3C53C9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M402.842 332.107C386.871 341.335 360.965 341.335 344.994 332.107C329.023 322.88 329.003 307.921 344.994 298.693C360.985 289.466 386.871 289.466 402.842 298.693C418.813 307.921 418.833 322.88 402.842 332.107Z",
    fill: "#09185E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M404.976 290.585C387.827 280.666 360.011 280.666 342.862 290.585C334.389 295.462 330.101 301.865 330 308.287H333.007C333.108 302.312 337.071 296.357 344.995 291.804C360.966 282.577 386.872 282.577 402.843 291.804C410.686 296.336 414.669 302.251 414.811 308.064C415.827 307.535 416.843 308.064 417.838 308.206C417.696 301.885 413.47 295.483 404.976 290.585Z",
    fill: "#7990FC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M412.676 322.982L384.575 320.198C384.797 319.727 384.915 319.214 384.921 318.694V318.246L413.123 314.608C413.617 313.82 413.838 312.892 413.753 311.966C413.997 309.934 412.534 308.612 409.69 309.161L384.839 316.255C384.812 315.624 384.631 315.01 384.311 314.466L407.536 301.926C406.075 300.714 404.511 299.633 402.862 298.694C401.406 297.862 399.9 297.123 398.352 296.478C396.454 296.748 394.698 297.633 393.353 298.999L381.588 311.925C380.868 311.548 380.113 311.241 379.333 311.011L389.879 293.653C385.376 292.566 380.773 291.953 376.143 291.824C373.694 292.843 371.496 294.383 369.702 296.336V297.576L372.912 310.36L371.713 310.523L367.65 292.068C362.976 292.466 358.362 293.386 353.894 294.812C352.308 295.977 350.88 297.343 349.647 298.877L347.717 297.231C346.762 297.678 345.847 298.145 344.953 298.674C343.5 299.509 342.108 300.446 340.788 301.478C339.392 303.78 338.234 306.218 337.334 308.755L335.729 308.267C335.158 310.938 334.885 313.665 334.916 316.397C334.838 319.264 335.307 322.12 336.298 324.811C337.441 326.308 338.75 327.672 340.199 328.876L342.393 328.246C343.389 329.809 344.532 331.272 345.807 332.616C349.513 334.595 353.451 336.104 357.531 337.108L359.766 334.669C361.308 336.218 363.084 337.514 365.029 338.51C369.536 339.083 374.088 339.219 378.622 338.917L375.046 324.689C375.835 324.649 376.622 324.568 377.403 324.446L380.633 331.295C381.5 333.206 382.98 334.773 384.839 335.746C386.231 336.446 387.706 336.965 389.228 337.291C392.606 336.506 395.899 335.397 399.063 333.978L381.121 323.328C381.385 323.206 381.649 323.104 381.893 322.962C382.481 322.637 383.021 322.234 383.498 321.763L402.984 326.986C405.065 327.64 407.284 327.717 409.405 327.21C410.668 325.943 411.767 324.522 412.676 322.982Z",
    fill: "#0B196D"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M372.607 315.136L366.512 286.885C359.4 287.698 349.2 294.303 347.331 300.177L372.607 315.136Z",
    fill: "#111E72"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M371.349 315.868L345.422 293.633C340.484 296.702 335.648 307.636 335.648 312.352L371.349 315.868Z",
    fill: "#111E72"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M371.065 316.579L335.243 305.909C334.369 309.974 333.008 320.014 338.595 325.827L371.065 316.579Z",
    fill: "#111E72"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M371.875 317.413L339.832 319.445C340.34 325.217 348.569 333.835 355.031 335.888L371.875 317.413Z",
    fill: "#111E72"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M373.461 317.8L357.429 328.897C360.782 334.852 371.368 339.059 378.683 338.511L373.461 317.8Z",
    fill: "#111E72"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M372.607 313.917L366.512 285.665C359.4 286.458 349.2 293.063 347.331 298.937L372.607 313.917Z",
    fill: "url(#paint13_linear_1_781)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M371.349 314.649L345.422 292.394C340.484 295.463 335.648 306.397 335.648 311.113L371.349 314.649Z",
    fill: "url(#paint14_linear_1_781)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M371.065 315.666L335.243 304.995C334.369 309.162 333.008 319.101 338.595 324.914L371.065 315.666Z",
    fill: "url(#paint15_linear_1_781)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M374.376 314.995L390.408 288.573C383.845 286.805 374.539 288.288 369.154 294.264L374.376 314.995Z",
    fill: "#111E72"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M390.407 288.593V287.353L374.375 313.755V314.995L390.407 288.593Z",
    fill: "#242993"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M369.154 293.043V294.282L374.376 314.993V313.754L369.967 294.587L369.154 293.043Z",
    fill: "#242993"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M374.376 313.754L390.408 287.332C383.845 285.564 374.539 287.048 369.154 293.023L374.376 313.754Z",
    fill: "url(#paint16_linear_1_781)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M375.959 315.381L408.002 298.003C404.507 294.344 397.416 292.251 392.804 296.865L375.959 315.381Z",
    fill: "#111E72"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M408.002 298.084V296.844L396.014 300.198L375.959 314.222V315.462L408.002 298.084Z",
    fill: "#242993"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M375.959 314.222L408.002 296.844C404.507 293.186 397.416 291.092 392.804 295.706L375.959 314.222Z",
    fill: "url(#paint17_linear_1_781)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M376.772 315.93L412.594 311.316C414.219 308.471 412.797 305.991 409.241 306.703L376.772 315.93Z",
    fill: "#242993"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M376.772 315.136L412.594 310.502C414.219 307.636 412.797 305.157 409.241 305.868L376.772 315.136Z",
    fill: "url(#paint18_linear_1_781)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M383.559 313.043C382.963 312.245 382.2 311.586 381.324 311.112C379.028 309.95 376.491 309.344 373.918 309.344C371.345 309.344 368.808 309.95 366.512 311.112C365.64 311.592 364.878 312.25 364.277 313.043H363.444V318.226C363.528 319.146 363.857 320.027 364.397 320.778C364.936 321.528 365.666 322.121 366.512 322.494C368.808 323.657 371.345 324.263 373.918 324.263C376.491 324.263 379.028 323.657 381.324 322.494C382.17 322.121 382.9 321.528 383.44 320.778C383.979 320.027 384.308 319.146 384.392 318.226V313.043H383.559Z",
    fill: "#2D36AD"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M377.241 321.905V323.938C377.543 323.891 377.842 323.823 378.135 323.735C378.5 323.633 378.561 321.701 378.561 321.701L377.241 321.884V321.905Z",
    fill: "#0B196D"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M375.227 317.595L380.144 328.022C381.017 329.929 382.496 331.494 384.35 332.473C386.863 333.761 389.642 334.441 392.466 334.459C395.289 334.476 398.077 333.831 400.605 332.575L375.227 317.595Z",
    fill: "#111E72"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M371.875 316.579L339.832 318.612C340.34 324.384 348.57 332.982 355.031 335.055L371.875 316.579Z",
    fill: "url(#paint19_linear_1_781)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M373.46 317.046L357.428 328.143C360.781 334.099 371.367 338.306 378.682 337.737L373.46 317.046Z",
    fill: "url(#paint20_linear_1_781)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M375.227 316.884L379.9 326.782C381.007 329.223 382.975 331.169 385.427 332.25C387.818 333.295 390.41 333.802 393.018 333.736C395.627 333.669 398.189 333.03 400.524 331.864L375.227 316.884Z",
    fill: "url(#paint21_linear_1_781)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M383.375 318.571V320.828C383.679 320.45 383.932 320.033 384.127 319.588C384.289 319.275 384.359 318.922 384.33 318.571H383.375Z",
    fill: "#0B196D"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M376.488 316.742L402.415 323.693C408.003 325.197 411.782 323.571 412.188 320.259L376.488 316.742Z",
    fill: "#111E72"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M376.488 316.153L402.415 323.104C408.003 324.608 411.782 322.982 412.188 319.689L376.488 316.153Z",
    fill: "url(#paint22_linear_1_781)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M381.325 317.413C379.033 318.586 376.494 319.198 373.919 319.198C371.343 319.198 368.805 318.586 366.512 317.413C362.449 315.055 362.449 311.315 366.512 308.856C368.808 307.693 371.345 307.087 373.919 307.087C376.492 307.087 379.029 307.693 381.325 308.856C385.409 311.132 385.409 314.953 381.325 317.413Z",
    fill: "#4149C7"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M380.795 316.579C378.664 317.661 376.308 318.225 373.917 318.225C371.527 318.225 369.171 317.661 367.04 316.579C363.24 314.384 363.24 310.827 367.04 308.632C369.171 307.55 371.527 306.987 373.917 306.987C376.308 306.987 378.664 307.55 380.795 308.632C384.595 310.827 384.595 314.384 380.795 316.579Z",
    fill: "#7990FC"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M376.913 314.345C375.984 314.816 374.957 315.062 373.916 315.062C372.874 315.062 371.847 314.816 370.919 314.345C370.553 314.224 370.234 313.992 370.008 313.68C369.783 313.368 369.661 312.992 369.661 312.607C369.661 312.222 369.783 311.846 370.008 311.534C370.234 311.222 370.553 310.99 370.919 310.869C371.847 310.398 372.874 310.152 373.916 310.152C374.957 310.152 375.984 310.398 376.913 310.869C377.279 310.99 377.597 311.222 377.823 311.534C378.049 311.846 378.17 312.222 378.17 312.607C378.17 312.992 378.049 313.368 377.823 313.68C377.597 313.992 377.279 314.224 376.913 314.345Z",
    fill: "#4149C7"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M370.963 311.316C371.889 310.835 372.917 310.584 373.96 310.584C375.003 310.584 376.031 310.835 376.957 311.316C377.26 311.459 377.527 311.668 377.738 311.929C377.949 312.189 378.099 312.494 378.176 312.82C378.211 312.396 378.112 311.972 377.894 311.607C377.675 311.243 377.347 310.956 376.957 310.787C376.028 310.316 375.002 310.07 373.96 310.07C372.919 310.07 371.892 310.316 370.963 310.787C370.577 310.959 370.253 311.247 370.039 311.612C369.824 311.976 369.728 312.398 369.764 312.82C369.834 312.493 369.978 312.187 370.186 311.926C370.395 311.665 370.66 311.456 370.963 311.316Z",
    fill: "#2D36AD"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M417.838 308.307L414.994 314.405L410.381 320.706L405.87 324.771L395.711 329.486L381.894 332.657L371.288 333.023L358.934 331.376L347.819 328.023L340.22 323.531L333.027 316.519V315.787H332.763L330 308.368V316.254C330.447 322.352 334.693 328.449 342.801 333.104C359.95 343.022 387.766 343.022 404.915 333.104C412.759 328.592 417.107 322.779 417.676 316.844V315.198C417.676 314.52 417.676 313.843 417.676 313.165L417.838 308.307Z",
    fill: "#2D36AD"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M414.811 308.166C414.973 314.263 410.991 320.523 402.843 325.218C386.872 334.446 360.966 334.446 344.995 325.218C336.867 320.543 332.804 314.405 333.007 308.288H330C330 314.853 334.185 321.438 342.862 326.458C360.011 336.356 387.827 336.356 404.976 326.458C413.653 321.458 417.94 314.873 417.838 308.308C416.822 308.105 415.827 307.637 414.811 308.166Z",
    fill: "#7990FC"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M373.928 332.413C363.809 332.641 353.8 330.276 344.852 325.543C336.928 320.97 332.661 314.873 332.661 308.369C332.661 301.865 337.07 296.174 344.852 291.641C360.884 282.394 386.953 282.394 402.984 291.641C410.645 296.072 414.932 301.966 415.176 308.247C415.42 314.527 411.112 320.95 402.984 325.543C394.043 330.274 384.041 332.639 373.928 332.413ZM373.928 285.178C363.91 284.984 354.007 287.348 345.157 292.048C337.618 296.397 333.412 302.21 333.311 308.308C333.209 314.405 337.375 320.503 345.157 324.994C361.026 334.161 386.851 334.161 402.72 324.994C410.502 320.503 414.709 314.548 414.546 308.206C414.383 301.865 410.198 296.397 402.72 292.068C393.86 287.355 383.942 284.983 373.908 285.178H373.928Z",
    fill: "#2D36AD"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M446.142 299.568C435.182 299.777 424.35 297.189 414.668 292.048C406.032 287.048 401.339 280.401 401.46 273.267C401.582 266.133 406.256 259.873 414.647 254.975C432.02 244.955 460.243 244.955 477.636 254.975C485.987 259.792 490.661 266.235 490.843 273.105C491.006 280.28 486.333 286.987 477.636 292.007C467.952 297.167 457.112 299.769 446.142 299.568ZM446.142 248.654C435.387 248.443 424.756 250.982 415.257 256.032C407.231 260.666 402.74 266.784 402.639 273.288C402.537 279.792 407.007 286.275 415.257 291.031C432.305 300.889 459.959 300.869 477.047 291.031C485.337 286.255 489.827 279.893 489.665 273.186C489.502 266.479 485.012 260.625 477.047 256.032C467.541 250.98 456.903 248.44 446.142 248.654Z",
    fill: "#0B196D"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M487.591 265.097V260.178L481.028 252.374L473.449 248.105L462.071 243.736L450.916 242.272H437.586L424.968 244.975L416.536 248.451L409.567 253.41L403.776 262.841V266.764C402.679 269.014 402.149 271.498 402.231 273.999H405.239C405.162 272.062 405.494 270.129 406.214 268.329L433.401 251.032L435.737 250.646L454.593 252.801L471.885 257.861L485.031 266.154C486.619 268.871 487.282 272.031 486.921 275.158H489.948C490.319 271.634 489.489 268.089 487.591 265.097Z",
    fill: "url(#paint23_linear_1_781)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M509.963 272.495L440.919 232.618L442.463 231.723L511.507 271.601L509.963 272.495Z",
    fill: "#5F74EA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M508.806 273.144L439.762 233.287L440.92 232.617L509.964 272.494L508.806 273.144Z",
    fill: "#3C53C9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M507.262 274.041L438.218 234.183L439.762 233.289L508.806 273.146L507.262 274.041Z",
    fill: "#5F74EA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M506.105 274.711L437.081 234.833L438.219 234.183L507.263 274.04L506.105 274.711Z",
    fill: "#3C53C9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M504.56 275.605L435.536 235.728L437.08 234.833L506.104 274.711L504.56 275.605Z",
    fill: "#5F74EA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M503.423 276.276L434.379 236.399L435.537 235.728L504.561 275.606L503.423 276.276Z",
    fill: "#3C53C9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M501.876 277.149L432.832 237.292L434.376 236.398L503.42 276.275L501.876 277.149Z",
    fill: "#5F74EA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M500.717 277.821L431.673 237.964L432.831 237.293L501.875 277.151L500.717 277.821Z",
    fill: "#3C53C9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M499.172 278.714L430.128 238.837L431.672 237.963L500.716 277.82L499.172 278.714Z",
    fill: "#5F74EA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M498.035 279.384L428.991 239.507L430.129 238.836L499.173 278.714L498.035 279.384Z",
    fill: "#3C53C9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M496.471 280.279L427.447 240.402L428.991 239.508L498.035 279.385L496.471 280.279Z",
    fill: "#5F74EA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M495.334 280.931L426.29 241.074L427.448 240.403L496.472 280.28L495.334 280.931Z",
    fill: "#3C53C9"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M493.789 281.824L424.745 241.967L426.289 241.073L495.333 280.93L493.789 281.824Z",
    fill: "#5F74EA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M492.632 282.495L423.608 242.618L424.746 241.967L493.79 281.824L492.632 282.495Z",
    fill: "#3C53C9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M491.088 283.39L422.044 243.512L423.609 242.618L492.632 282.495L491.088 283.39Z",
    fill: "#5F74EA"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M489.951 284.039L420.907 244.182L422.045 243.511L491.089 283.388L489.951 284.039Z",
    fill: "#3C53C9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M488.387 284.933L419.363 245.076L420.908 244.182L489.951 284.039L488.387 284.933Z",
    fill: "#5F74EA"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M487.248 285.604L418.204 245.727L419.362 245.076L488.386 284.933L487.248 285.604Z",
    fill: "#3C53C9"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M485.702 286.499L416.658 246.621L418.203 245.727L487.246 285.604L485.702 286.499Z",
    fill: "#5F74EA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M484.544 287.171L415.52 247.293L416.658 246.622L485.702 286.5L484.544 287.171Z",
    fill: "#3C53C9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M483.001 288.065L413.977 248.188L415.522 247.294L484.545 287.171L483.001 288.065Z",
    fill: "#5F74EA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M481.861 288.715L412.817 248.837L413.975 248.187L482.999 288.064L481.861 288.715Z",
    fill: "#3C53C9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M480.317 289.609L411.273 249.731L412.818 248.837L481.861 288.714L480.317 289.609Z",
    fill: "#5F74EA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M479.16 290.28L410.116 250.403L411.274 249.732L480.318 289.609L479.16 290.28Z",
    fill: "#3C53C9"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M477.616 291.174L408.572 251.296L410.116 250.402L479.16 290.279L477.616 291.174Z",
    fill: "#5F74EA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M476.458 291.823L407.434 251.966L408.572 251.295L477.616 291.173L476.458 291.823Z",
    fill: "#3C53C9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M474.915 292.718L405.891 252.861L407.436 251.967L476.459 291.824L474.915 292.718Z",
    fill: "#5F74EA"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M473.776 293.389L404.732 253.512L405.89 252.861L474.914 292.718L473.776 293.389Z",
    fill: "#3C53C9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M472.232 294.284L403.188 254.406L404.733 253.512L473.776 293.389L472.232 294.284Z",
    fill: "#5F74EA"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M471.073 294.935L402.049 255.077L403.187 254.407L472.231 294.284L471.073 294.935Z",
    fill: "#3C53C9"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M469.528 295.828L400.504 255.971L402.048 255.077L471.072 294.934L469.528 295.828Z",
    fill: "#5F74EA"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M468.391 296.499L399.347 256.622L400.505 255.971L469.529 295.828L468.391 296.499Z",
    fill: "#3C53C9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M466.827 297.393L397.803 257.516L399.348 256.622L468.391 296.499L466.827 297.393Z",
    fill: "#5F74EA"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M465.687 298.064L396.643 258.186L397.801 257.516L466.825 297.393L465.687 298.064Z",
    fill: "#3C53C9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M464.144 298.938L395.1 259.081L396.645 258.186L465.688 298.064L464.144 298.938Z",
    fill: "#5F74EA"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M462.984 299.609L393.961 259.752L395.099 259.081L464.143 298.938L462.984 299.609Z",
    fill: "#3C53C9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M461.442 300.503L392.418 260.626L393.963 259.752L462.986 299.609L461.442 300.503Z",
    fill: "#5F74EA"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M460.304 301.174L391.26 261.296L392.418 260.625L461.442 300.503L460.304 301.174Z",
    fill: "#3C53C9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M458.759 302.068L389.715 262.19L391.26 261.296L460.303 301.173L458.759 302.068Z",
    fill: "#5F74EA"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M457.603 302.719L388.579 262.862L389.717 262.191L458.761 302.068L457.603 302.719Z",
    fill: "#3C53C9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M456.058 303.612L387.014 263.755L388.579 262.861L457.603 302.718L456.058 303.612Z",
    fill: "#5F74EA"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M454.921 304.283L385.877 264.405L387.015 263.755L456.059 303.612L454.921 304.283Z",
    fill: "#3C53C9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M453.355 305.177L384.331 265.3L385.876 264.406L454.919 304.283L453.355 305.177Z",
    fill: "#5F74EA"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M452.217 305.828L383.173 265.971L384.331 265.3L453.355 305.177L452.217 305.828Z",
    fill: "#3C53C9"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M450.673 306.723L381.629 266.866L383.174 265.971L452.217 305.828L450.673 306.723Z",
    fill: "#5F74EA"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M449.515 307.393L380.491 267.515L381.629 266.865L450.673 306.722L449.515 307.393Z",
    fill: "#3C53C9"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M447.97 308.287L378.946 268.41L380.491 267.515L449.514 307.393L447.97 308.287Z",
    fill: "#5F74EA"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M446.832 308.958L377.788 269.081L378.946 268.41L447.97 308.288L446.832 308.958Z",
    fill: "#3C53C9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M445.287 309.852L376.243 269.975L377.788 269.081L446.831 308.958L445.287 309.852Z",
    fill: "#5F74EA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M444.13 310.502L375.086 270.645L376.245 269.974L445.288 309.852L444.13 310.502Z",
    fill: "#3C53C9"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M475.076 290.178C459.105 299.406 433.199 299.406 417.228 290.178C401.257 280.951 401.237 265.992 417.228 256.764C433.219 247.537 459.105 247.537 475.076 256.764C491.047 265.992 491.067 280.951 475.076 290.178Z",
    fill: "#09185E"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M477.209 248.654C460.06 238.756 432.244 238.756 415.094 248.654C406.621 253.553 402.334 259.955 402.233 266.357H405.24C405.341 260.402 409.304 254.447 417.228 249.894C433.199 240.667 459.105 240.667 475.076 249.894C482.919 254.406 486.902 260.321 487.044 266.256C488.06 265.707 489.076 266.256 490.071 266.398C489.99 259.955 485.703 253.553 477.209 248.654Z",
    fill: "#7990FC"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M484.91 281.051L456.809 278.267C457.031 277.796 457.148 277.283 457.154 276.763V276.316L485.357 272.698C485.849 271.917 486.07 270.995 485.987 270.076C486.23 268.043 484.747 266.722 481.923 267.271L457.073 274.364C457.041 273.728 456.86 273.109 456.544 272.556L479.667 260.035C478.208 258.817 476.644 257.729 474.994 256.783C473.534 255.96 472.028 255.22 470.483 254.568C468.589 254.846 466.835 255.73 465.485 257.088L453.72 270.015C452.998 269.641 452.243 269.334 451.465 269.1L462.01 251.743C457.507 250.662 452.904 250.056 448.275 249.934C445.826 250.953 443.628 252.493 441.834 254.446V255.686L445.044 268.47L443.845 268.613L439.781 250.158C435.102 250.557 430.481 251.477 426.005 252.901C424.435 254.078 423.015 255.443 421.779 256.966L419.747 255.32C418.792 255.788 417.857 256.255 416.984 256.763C415.522 257.603 414.123 258.547 412.798 259.588C411.404 261.888 410.253 264.327 409.364 266.865L407.759 266.377C407.175 269.046 406.902 271.774 406.946 274.507C406.868 277.367 407.337 280.216 408.328 282.901C409.472 284.398 410.78 285.762 412.229 286.966L414.423 286.336C415.407 287.906 416.551 289.371 417.837 290.706C421.648 292.67 425.699 294.132 429.886 295.055L432.101 292.616C433.654 294.161 435.436 295.456 437.384 296.458C441.891 297.03 446.443 297.166 450.977 296.864L447.401 282.637C448.192 282.617 448.98 282.535 449.758 282.393L452.989 289.263C453.855 291.162 455.327 292.721 457.174 293.693C458.574 294.391 460.055 294.91 461.583 295.238C464.963 294.463 468.258 293.353 471.418 291.925L453.395 281.275C453.659 281.153 453.923 281.051 454.167 280.909C454.752 280.573 455.291 280.163 455.772 279.69L475.258 284.913C477.339 285.566 479.558 285.644 481.679 285.137C482.917 283.91 484.002 282.539 484.91 281.051Z",
    fill: "#0B196D"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M444.841 273.227L438.746 244.975C431.634 245.768 421.414 252.374 419.565 258.247L444.841 273.227Z",
    fill: "#111E72"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M443.581 273.959L417.654 251.601C412.716 254.67 407.88 265.605 407.88 270.321L443.581 273.959Z",
    fill: "#111E72"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M443.298 274.732L407.537 264C406.643 268.065 405.302 278.086 410.89 283.919L443.298 274.732Z",
    fill: "#111E72"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M444.109 275.524L412.066 277.556C412.574 283.308 420.803 291.926 427.265 293.979L444.109 275.524Z",
    fill: "#111E72"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M445.695 275.89L429.663 286.926C433.016 292.881 443.602 297.089 450.917 296.52L445.695 275.89Z",
    fill: "#111E72"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M444.841 271.988L438.746 243.736C431.634 244.529 421.414 251.134 419.565 257.008L444.841 271.988Z",
    fill: "url(#paint24_linear_1_781)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M443.58 272.698L417.694 250.483C412.756 253.532 407.92 264.487 407.92 269.182L443.58 272.698Z",
    fill: "url(#paint25_linear_1_781)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M443.298 273.736L407.537 263.085C406.643 267.15 405.302 277.17 410.89 283.004L443.298 273.736Z",
    fill: "url(#paint26_linear_1_781)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M446.609 273.065L462.641 246.642C456.078 244.894 446.772 246.358 441.387 252.333L446.609 273.065Z",
    fill: "#111E72"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M462.64 246.662V245.443L446.608 271.824V273.064L462.64 246.662Z",
    fill: "#242993"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M441.387 251.134V252.374L446.609 273.064V271.825L442.2 252.679L441.387 251.134Z",
    fill: "#242993"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M446.609 271.825L462.641 245.403C456.078 243.635 446.772 245.118 441.387 251.094L446.609 271.825Z",
    fill: "url(#paint27_linear_1_781)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M448.175 273.531L480.218 256.153C476.703 252.515 469.632 250.401 465.02 255.015L448.175 273.531Z",
    fill: "#111E72"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M480.236 256.153V254.934L468.248 258.287L448.193 272.291V273.531L480.236 256.153Z",
    fill: "#242993"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M448.175 272.292L480.218 254.934C476.703 251.276 469.632 249.183 465.02 253.776L448.175 272.292Z",
    fill: "url(#paint28_linear_1_781)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M449.007 274.019L484.748 269.385C486.373 266.52 484.951 264.04 481.395 264.751L449.007 274.019Z",
    fill: "#242993"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M449.007 273.206L484.748 268.633C486.373 265.787 484.951 263.308 481.395 264.019L449.007 273.206Z",
    fill: "url(#paint29_linear_1_781)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M455.792 271.112C455.184 270.331 454.424 269.681 453.557 269.202C451.265 268.028 448.726 267.416 446.151 267.416C443.576 267.416 441.037 268.028 438.745 269.202C437.874 269.675 437.113 270.326 436.51 271.112H435.677V276.295C435.764 277.217 436.094 278.1 436.633 278.853C437.172 279.607 437.9 280.204 438.745 280.584C441.041 281.746 443.578 282.352 446.151 282.352C448.724 282.352 451.262 281.746 453.557 280.584C454.402 280.204 455.131 279.607 455.67 278.853C456.208 278.1 456.538 277.217 456.625 276.295V271.112H455.792Z",
    fill: "#2D36AD"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M449.477 279.975V282.008L450.371 281.805C450.736 281.683 450.797 279.772 450.797 279.772L449.477 279.955V279.975Z",
    fill: "#0B196D"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M447.463 275.665L452.38 286.112C453.248 288.017 454.729 289.577 456.586 290.542C459.096 291.84 461.877 292.525 464.702 292.543C467.527 292.561 470.316 291.91 472.841 290.644L447.463 275.665Z",
    fill: "#111E72"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M444.111 274.73L412.068 276.763C412.576 282.515 420.806 291.133 427.267 293.185L444.111 274.73Z",
    fill: "url(#paint30_linear_1_781)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M445.696 275.116L429.664 286.234C433.017 292.169 443.603 296.396 450.918 295.827L445.696 275.116Z",
    fill: "url(#paint31_linear_1_781)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M447.463 274.954L452.238 284.893C453.351 287.335 455.316 289.286 457.765 290.381C460.159 291.418 462.75 291.919 465.358 291.848C467.966 291.778 470.527 291.139 472.862 289.975L447.463 274.954Z",
    fill: "url(#paint32_linear_1_781)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M455.613 276.765V279.022C455.92 278.638 456.173 278.214 456.365 277.761C456.527 277.456 456.598 277.109 456.568 276.765H455.613Z",
    fill: "#0B196D"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M448.725 274.73L474.591 281.763C480.179 283.267 483.958 281.641 484.364 278.348L448.725 274.73Z",
    fill: "#111E72"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M448.725 274.223L474.591 281.194C480.179 282.678 483.958 281.072 484.364 277.759L448.725 274.223Z",
    fill: "url(#paint33_linear_1_781)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M453.559 275.402C451.263 276.564 448.726 277.17 446.153 277.17C443.579 277.17 441.042 276.564 438.746 275.402C434.683 273.024 434.683 269.203 438.746 266.845C441.039 265.671 443.577 265.059 446.153 265.059C448.728 265.059 451.267 265.671 453.559 266.845C457.643 269.203 457.643 273.024 453.559 275.402Z",
    fill: "#4149C7"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M453.029 274.731C450.898 275.813 448.542 276.377 446.152 276.377C443.761 276.377 441.405 275.813 439.274 274.731C435.474 272.536 435.474 268.979 439.274 266.784C441.408 265.712 443.763 265.153 446.152 265.153C448.54 265.153 450.895 265.712 453.029 266.784C456.829 268.898 456.829 272.455 453.029 274.731Z",
    fill: "#7990FC"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M449.149 272.414C448.208 272.902 447.162 273.157 446.102 273.157C445.041 273.157 443.996 272.902 443.054 272.414C442.685 272.299 442.363 272.07 442.134 271.759C441.905 271.448 441.781 271.072 441.781 270.686C441.781 270.3 441.905 269.924 442.134 269.613C442.363 269.302 442.685 269.073 443.054 268.958C443.992 268.46 445.039 268.199 446.102 268.199C447.164 268.199 448.211 268.46 449.149 268.958C449.518 269.073 449.84 269.302 450.069 269.613C450.298 269.924 450.422 270.3 450.422 270.686C450.422 271.072 450.298 271.448 450.069 271.759C449.84 272.07 449.518 272.299 449.149 272.414Z",
    fill: "#4149C7"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M443.155 269.386C444.096 268.897 445.142 268.643 446.202 268.643C447.263 268.643 448.308 268.897 449.25 269.386C449.551 269.529 449.815 269.739 450.023 269.999C450.231 270.26 450.376 270.564 450.449 270.89C450.506 270.466 450.418 270.035 450.201 269.666C449.984 269.298 449.649 269.013 449.25 268.857C448.312 268.359 447.265 268.098 446.202 268.098C445.14 268.098 444.093 268.359 443.155 268.857C442.764 269.026 442.437 269.313 442.218 269.677C441.999 270.042 441.901 270.466 441.935 270.89C442.016 270.565 442.166 270.261 442.377 270.002C442.588 269.742 442.853 269.531 443.155 269.386Z",
    fill: "#2D36AD"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M490.071 266.397L487.227 272.495L482.594 278.795L478.104 282.86L467.944 287.555L454.269 290.99L443.663 291.336L431.309 289.69L420.195 286.356L412.595 281.844L405.321 274.73C405.321 274.487 405.321 274.243 405.321 273.999H405.057L402.233 266.6V274.487C402.68 280.584 406.926 286.681 415.034 291.336C432.183 301.234 459.999 301.234 477.149 291.336C484.992 286.803 489.34 280.99 489.909 275.076V273.43C489.909 272.759 489.909 272.068 489.909 271.397L490.071 266.397Z",
    fill: "#2D36AD"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M487.043 266.256C487.206 272.353 483.223 278.593 475.076 283.309C459.105 292.536 433.198 292.536 417.228 283.309C409.1 278.634 405.138 272.496 405.239 266.358H402.232C402.131 272.923 406.418 279.528 415.094 284.528C432.243 294.447 460.06 294.447 477.209 284.528C485.885 279.528 490.152 272.943 490.071 266.398C489.055 266.195 488.059 265.707 487.043 266.256Z",
    fill: "#7990FC"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M446.142 290.483C436.019 290.683 426.011 288.297 417.066 283.552C409.142 278.979 404.875 272.861 404.875 266.357C404.875 259.853 409.284 254.162 417.066 249.65C433.098 240.382 459.167 240.382 475.198 249.65C482.859 254.061 487.146 259.955 487.39 266.235C487.634 272.516 483.326 278.938 475.198 283.552C466.259 288.295 456.259 290.68 446.142 290.483ZM446.142 243.248C436.121 243.049 426.216 245.421 417.371 250.138C409.832 254.467 405.626 260.3 405.525 266.398C405.423 272.495 409.589 278.593 417.371 283.105C433.24 292.271 459.065 292.271 474.934 283.105C482.737 278.593 486.922 272.637 486.76 266.296C486.597 259.955 482.412 254.487 474.934 250.179C466.086 245.447 456.174 243.061 446.142 243.248Z",
    fill: "#2D36AD"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M518.398 257.637C507.431 257.856 496.589 255.268 486.903 250.117C478.288 245.137 473.595 238.471 473.717 231.357C473.838 224.243 478.512 217.943 486.903 213.065C504.256 203.045 532.499 203.045 549.892 213.065C558.243 217.861 562.917 224.304 563.099 231.194C563.282 238.085 558.589 245.056 549.892 250.076C540.212 255.245 529.369 257.848 518.398 257.637ZM518.398 206.723C507.643 206.512 497.012 209.052 487.513 214.101C479.385 218.735 474.997 224.873 474.895 231.377C474.793 237.881 479.264 244.345 487.513 249.121C504.54 258.958 532.215 258.958 549.303 249.121C557.593 244.324 562.084 237.983 561.921 231.255C561.758 224.528 557.268 218.695 549.303 214.101C539.792 209.046 529.146 206.506 518.377 206.723H518.398Z",
    fill: "#0B196D"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M559.927 223.167V218.249L553.344 210.464L545.704 206.176L534.326 201.806L523.17 200.342H509.841L497.223 203.045L488.811 206.541L481.862 211.501L476.071 220.911V224.854C474.999 227.096 474.49 229.566 474.588 232.049H477.595C477.519 230.118 477.851 228.192 478.57 226.399L505.757 209.102C506.529 208.94 507.322 208.818 508.094 208.696L526.95 210.85L544.241 215.911L557.387 224.224C558.967 226.937 559.63 230.088 559.277 233.208H562.305C562.663 229.689 561.826 226.151 559.927 223.167Z",
    fill: "url(#paint34_linear_1_781)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M582.198 230.566L513.154 190.709L514.698 189.815L583.742 229.672L582.198 230.566Z",
    fill: "#5F74EA"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M581.041 231.236L511.997 191.358L513.155 190.708L582.199 230.565L581.041 231.236Z",
    fill: "#3C53C9"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M579.497 232.13L510.453 192.253L511.997 191.358L581.041 231.236L579.497 232.13Z",
    fill: "#5F74EA"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M578.339 232.782L509.316 192.925L510.454 192.254L579.497 232.132L578.339 232.782Z",
    fill: "#3C53C9"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M576.794 233.675L507.771 193.818L509.315 192.924L578.339 232.781L576.794 233.675Z",
    fill: "#5F74EA"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M575.658 234.347L506.614 194.469L507.772 193.819L576.796 233.676L575.658 234.347Z",
    fill: "#3C53C9"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M574.111 235.24L505.067 195.363L506.611 194.469L575.655 234.346L574.111 235.24Z",
    fill: "#5F74EA"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M572.951 235.911L503.908 196.034L505.066 195.363L574.11 235.241L572.951 235.911Z",
    fill: "#3C53C9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M571.409 236.805L502.365 196.928L503.909 196.033L572.953 235.911L571.409 236.805Z",
    fill: "#5F74EA"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M570.271 237.455L501.227 197.578L502.365 196.927L571.409 236.805L570.271 237.455Z",
    fill: "#3C53C9"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M568.708 238.349L499.684 198.472L501.228 197.578L570.272 237.455L568.708 238.349Z",
    fill: "#5F74EA"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M567.571 239.02L498.527 199.143L499.685 198.472L568.709 238.349L567.571 239.02Z",
    fill: "#3C53C9"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M566.024 239.914L496.98 200.037L498.524 199.143L567.568 239.02L566.024 239.914Z",
    fill: "#5F74EA"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M564.866 240.565L495.843 200.708L496.981 200.037L566.024 239.914L564.866 240.565Z",
    fill: "#3C53C9"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M563.323 241.459L494.279 201.581L495.844 200.708L564.867 240.565L563.323 241.459Z",
    fill: "#5F74EA"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M562.186 242.13L493.142 202.253L494.28 201.582L563.324 241.459L562.186 242.13Z",
    fill: "#3C53C9"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M560.642 243.025L491.598 203.148L493.142 202.254L562.186 242.131L560.642 243.025Z",
    fill: "#5F74EA"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M559.483 243.676L490.439 203.819L491.597 203.148L560.641 243.026L559.483 243.676Z",
    fill: "#3C53C9"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M557.937 244.569L488.893 204.712L490.437 203.818L559.481 243.675L557.937 244.569Z",
    fill: "#5F74EA"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M556.778 245.241L487.755 205.364L488.893 204.714L557.937 244.571L556.778 245.241Z",
    fill: "#3C53C9"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M555.236 246.134L486.212 206.257L487.756 205.363L556.78 245.24L555.236 246.134Z",
    fill: "#5F74EA"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M554.098 246.784L485.054 206.926L486.212 206.256L555.236 246.133L554.098 246.784Z",
    fill: "#3C53C9"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M552.554 247.679L483.51 207.822L485.054 206.927L554.098 246.784L552.554 247.679Z",
    fill: "#5F74EA"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M551.395 248.35L482.351 208.473L483.509 207.823L552.553 247.68L551.395 248.35Z",
    fill: "#3C53C9"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M549.851 249.244L480.807 209.367L482.351 208.472L551.395 248.35L549.851 249.244Z",
    fill: "#5F74EA"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M548.713 249.916L479.669 210.038L480.807 209.367L549.851 249.245L548.713 249.916Z",
    fill: "#3C53C9"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M547.15 250.81L478.126 210.932L479.671 210.038L548.714 249.915L547.15 250.81Z",
    fill: "#5F74EA"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M546.011 251.461L476.967 211.604L478.125 210.933L547.149 250.81L546.011 251.461Z",
    fill: "#3C53C9"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M544.467 252.354L475.423 212.497L476.968 211.603L546.011 251.46L544.467 252.354Z",
    fill: "#5F74EA"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M543.308 253.025L474.284 213.148L475.422 212.497L544.466 252.354L543.308 253.025Z",
    fill: "#3C53C9"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M541.763 253.918L472.719 214.041L474.284 213.146L543.307 253.024L541.763 253.918Z",
    fill: "#5F74EA"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M540.626 254.569L471.582 214.712L472.72 214.041L541.764 253.919L540.626 254.569Z",
    fill: "#3C53C9"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M539.062 255.464L470.038 215.607L471.582 214.713L540.626 254.57L539.062 255.464Z",
    fill: "#5F74EA"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M537.925 256.134L468.881 216.257L470.039 215.607L539.063 255.464L537.925 256.134Z",
    fill: "#3C53C9"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M536.38 257.028L467.336 217.151L468.881 216.256L537.924 256.134L536.38 257.028Z",
    fill: "#5F74EA"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M535.223 257.7L466.199 217.823L467.337 217.152L536.381 257.029L535.223 257.7Z",
    fill: "#3C53C9"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M533.677 258.592L464.653 218.715L466.197 217.821L535.221 257.698L533.677 258.592Z",
    fill: "#5F74EA"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M532.539 259.244L463.495 219.366L464.653 218.716L533.677 258.593L532.539 259.244Z",
    fill: "#3C53C9"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M530.994 260.139L461.95 220.261L463.494 219.367L532.538 259.244L530.994 260.139Z",
    fill: "#5F74EA"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M529.837 260.809L460.793 220.932L461.951 220.261L530.995 260.138L529.837 260.809Z",
    fill: "#3C53C9"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M528.293 261.704L459.249 221.826L460.794 220.932L529.837 260.809L528.293 261.704Z",
    fill: "#5F74EA"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M527.136 262.354L458.112 222.497L459.25 221.826L528.294 261.703L527.136 262.354Z",
    fill: "#3C53C9"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M525.59 263.248L456.566 223.391L458.111 222.497L527.134 262.354L525.59 263.248Z",
    fill: "#5F74EA"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M524.452 263.918L455.408 224.041L456.566 223.39L525.59 263.247L524.452 263.918Z",
    fill: "#3C53C9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M522.908 264.813L453.864 224.936L455.409 224.041L524.452 263.919L522.908 264.813Z",
    fill: "#5F74EA"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M521.75 265.463L452.726 225.606L453.864 224.935L522.908 264.812L521.75 265.463Z",
    fill: "#3C53C9"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M520.207 266.357L451.163 226.5L452.728 225.606L521.751 265.463L520.207 266.357Z",
    fill: "#5F74EA"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M519.067 267.028L450.023 227.151L451.161 226.5L520.205 266.357L519.067 267.028Z",
    fill: "#3C53C9"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M517.502 267.923L448.478 228.046L450.022 227.151L519.066 267.029L517.502 267.923Z",
    fill: "#5F74EA"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M516.365 268.573L447.321 228.716L448.479 228.046L517.503 267.923L516.365 268.573Z",
    fill: "#3C53C9"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M547.309 248.309C531.338 257.537 505.432 257.537 489.461 248.309C473.49 239.082 473.47 224.122 489.461 214.895C505.452 205.667 531.338 205.667 547.309 214.895C563.28 224.122 563.28 239.041 547.309 248.309Z",
    fill: "#09185E"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M549.444 206.724C532.294 196.826 504.478 196.826 487.329 206.724C478.856 211.622 474.568 218.025 474.467 224.447H477.474C477.575 218.472 481.538 212.517 489.462 207.964C505.433 198.737 531.339 198.737 547.31 207.964C555.153 212.496 559.136 218.391 559.278 224.224C560.294 223.695 561.31 224.224 562.305 224.366C562.204 218.045 557.896 211.724 549.444 206.724Z",
    fill: "#7990FC"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M557.145 239.122L529.044 236.358C529.264 235.886 529.382 235.374 529.389 234.854V234.406L557.592 230.748C558.085 229.967 558.307 229.046 558.222 228.126C558.466 226.094 556.983 224.772 554.158 225.321L529.45 232.415C529.423 231.784 529.242 231.17 528.922 230.626L552.045 218.086C550.59 216.867 549.025 215.786 547.372 214.854C545.912 214.024 544.406 213.277 542.861 212.618C540.965 212.904 539.211 213.795 537.862 215.159L526.098 228.085C525.38 227.703 524.624 227.396 523.842 227.171L534.388 209.793C529.883 208.722 525.281 208.116 520.652 207.984C518.204 209.003 516.006 210.543 514.211 212.496V213.756L517.422 226.541L516.223 226.703L512.159 208.248C507.48 208.641 502.859 209.555 498.383 210.972C496.808 212.143 495.388 213.509 494.156 215.037L492.125 213.37C491.17 213.838 490.235 214.305 489.361 214.834C487.9 215.666 486.501 216.604 485.176 217.638C483.785 219.94 482.635 222.378 481.742 224.915L480.136 224.427C479.555 227.097 479.283 229.825 479.324 232.557C479.243 235.418 479.712 238.267 480.705 240.951C481.838 242.457 483.148 243.822 484.607 245.016L486.801 244.406C487.79 245.973 488.934 247.437 490.215 248.776C493.917 250.757 497.857 252.26 501.939 253.248L504.153 250.809C505.711 252.353 507.492 253.655 509.436 254.67C513.944 255.236 518.497 255.366 523.03 255.057L519.454 240.931C520.243 240.891 521.03 240.809 521.81 240.687L525.041 247.536C525.908 249.436 527.38 250.994 529.227 251.967C530.622 252.674 532.105 253.193 533.636 253.512C537.014 252.74 540.308 251.637 543.471 250.219L525.448 239.549C525.712 239.427 525.976 239.325 526.22 239.183C526.8 238.848 527.339 238.445 527.825 237.984L547.311 243.207C549.391 243.865 551.613 243.935 553.732 243.41C555.052 242.136 556.199 240.694 557.145 239.122Z",
    fill: "#0B196D"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M517.076 231.297L510.98 203.045C503.868 203.858 493.648 210.464 491.799 216.317L517.076 231.297Z",
    fill: "#111E72"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M515.814 232.048L489.887 209.813C484.949 212.862 480.113 223.817 480.113 228.512L515.814 232.048Z",
    fill: "#111E72"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M515.531 232.719L479.709 222.069C478.815 226.134 477.474 236.154 483.062 241.987L515.531 232.719Z",
    fill: "#111E72"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M516.344 233.614L484.301 235.646C484.809 241.419 493.038 250.016 499.5 252.089L516.344 233.614Z",
    fill: "#111E72"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M517.93 233.96L501.898 245.057C505.251 251.012 515.837 255.22 523.152 254.651L517.93 233.96Z",
    fill: "#111E72"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M517.076 230.016L510.98 201.765C503.868 202.578 493.648 209.183 491.799 215.057L517.076 230.016Z",
    fill: "url(#paint35_linear_1_781)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M515.814 230.789L489.887 208.554C484.949 211.602 480.113 222.558 480.113 227.273L515.814 230.789Z",
    fill: "url(#paint36_linear_1_781)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M515.531 231.806L479.709 221.155C478.815 225.22 477.474 235.24 483.062 241.074L515.531 231.806Z",
    fill: "url(#paint37_linear_1_781)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M518.843 231.134L534.875 204.711C528.312 202.943 519.006 204.427 513.621 210.402L518.843 231.134Z",
    fill: "#111E72"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M534.875 204.752V203.512L518.844 229.894V231.134L534.875 204.752Z",
    fill: "#242993"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M513.621 209.203V210.443L518.843 231.134V229.894L514.434 210.748L513.621 209.203Z",
    fill: "#242993"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M518.843 230.017L534.875 203.595C528.312 201.826 519.006 203.31 513.621 209.286L518.843 230.017Z",
    fill: "url(#paint38_linear_1_781)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M520.426 231.602L552.469 214.244C548.954 210.586 541.863 208.492 537.271 213.086L520.426 231.602Z",
    fill: "#111E72"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M552.469 214.244V213.004L540.481 216.357L520.426 230.382V231.601L552.469 214.244Z",
    fill: "#242993"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M520.426 230.383L552.469 213.005C548.954 209.346 541.863 207.253 537.271 211.846L520.426 230.383Z",
    fill: "url(#paint39_linear_1_781)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M521.322 232.049L557.144 227.415C558.769 224.549 557.327 222.07 553.791 222.781L521.322 232.049Z",
    fill: "#242993"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M521.322 231.297L557.144 226.663C558.769 223.797 557.327 221.317 553.791 222.029L521.322 231.297Z",
    fill: "url(#paint40_linear_1_781)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M528.027 229.202C527.426 228.409 526.665 227.751 525.792 227.272C523.497 226.109 520.959 225.503 518.386 225.503C515.813 225.503 513.276 226.109 510.98 227.272C510.104 227.745 509.341 228.404 508.745 229.202H507.912V234.365C507.993 235.289 508.32 236.174 508.86 236.929C509.399 237.683 510.131 238.279 510.98 238.654C513.276 239.816 515.813 240.422 518.386 240.422C520.959 240.422 523.497 239.816 525.792 238.654C526.641 238.279 527.373 237.683 527.912 236.929C528.452 236.174 528.78 235.289 528.861 234.365V229.202H528.027Z",
    fill: "#2D36AD"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M521.708 238.145V240.178L522.602 239.975C522.968 239.873 523.029 237.942 523.029 237.942L521.708 238.125V238.145Z",
    fill: "#0B196D"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M519.695 233.754L524.612 244.181C525.479 246.087 526.96 247.647 528.818 248.612C531.327 249.908 534.107 250.594 536.931 250.615C539.755 250.636 542.544 249.992 545.073 248.734L519.695 233.754Z",
    fill: "#111E72"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M516.343 232.738L484.3 234.771C484.808 240.523 493.037 249.141 499.499 251.214L516.343 232.738Z",
    fill: "url(#paint41_linear_1_781)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M517.928 233.205L501.896 244.241C505.249 250.197 515.835 254.404 523.15 253.835L517.928 233.205Z",
    fill: "url(#paint42_linear_1_781)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M519.695 233.043L524.368 242.941C525.475 245.382 527.443 247.328 529.895 248.409C532.287 249.448 534.878 249.953 537.486 249.886C540.094 249.819 542.655 249.183 544.992 248.022L519.695 233.043Z",
    fill: "url(#paint43_linear_1_781)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M527.842 234.731V236.988C528.147 236.61 528.4 236.193 528.594 235.748C528.756 235.435 528.827 235.082 528.797 234.731H527.842Z",
    fill: "#0B196D"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M520.954 232.88L546.881 239.851C552.468 241.335 556.248 239.729 556.654 236.416L520.954 232.88Z",
    fill: "#111E72"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M520.954 232.312L546.881 239.263C552.468 240.767 556.248 239.141 556.654 235.848L520.954 232.312Z",
    fill: "url(#paint44_linear_1_781)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M525.794 233.472C523.498 234.634 520.961 235.24 518.388 235.24C515.815 235.24 513.277 234.634 510.982 233.472C506.918 231.114 506.918 227.374 510.982 224.915C513.277 223.752 515.815 223.147 518.388 223.147C520.961 223.147 523.498 223.752 525.794 224.915C529.878 227.273 529.878 231.114 525.794 233.472Z",
    fill: "#4149C7"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M525.265 232.739C523.13 233.812 520.775 234.371 518.387 234.371C515.998 234.371 513.643 233.812 511.509 232.739C507.709 230.544 507.709 226.988 511.509 224.792C513.64 223.71 515.996 223.147 518.387 223.147C520.777 223.147 523.133 223.71 525.265 224.792C529.064 226.988 529.064 230.544 525.265 232.739Z",
    fill: "#7990FC"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M521.323 230.484C520.394 230.955 519.367 231.201 518.326 231.201C517.284 231.201 516.258 230.955 515.329 230.484C514.96 230.369 514.638 230.14 514.409 229.829C514.18 229.518 514.057 229.142 514.057 228.756C514.057 228.37 514.18 227.994 514.409 227.683C514.638 227.372 514.96 227.143 515.329 227.029C516.258 226.557 517.284 226.312 518.326 226.312C519.367 226.312 520.394 226.557 521.323 227.029C521.692 227.143 522.014 227.372 522.243 227.683C522.472 227.994 522.595 228.37 522.595 228.756C522.595 229.142 522.472 229.518 522.243 229.829C522.014 230.14 521.692 230.369 521.323 230.484Z",
    fill: "#4149C7"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M515.39 227.455C516.319 226.984 517.345 226.738 518.387 226.738C519.428 226.738 520.455 226.984 521.384 227.455C521.686 227.602 521.951 227.815 522.159 228.079C522.367 228.343 522.511 228.651 522.583 228.979C522.619 228.558 522.523 228.136 522.308 227.771C522.093 227.407 521.77 227.119 521.384 226.947C520.455 226.476 519.428 226.23 518.387 226.23C517.345 226.23 516.319 226.476 515.39 226.947C515 227.116 514.672 227.402 514.453 227.767C514.235 228.132 514.136 228.556 514.171 228.979C514.251 228.652 514.401 228.346 514.612 228.083C514.822 227.819 515.088 227.605 515.39 227.455Z",
    fill: "#2D36AD"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M562.306 224.469L559.461 230.566L554.828 236.867L550.338 240.932L540.178 245.647L526.361 248.818L515.755 249.184L503.401 247.537L492.327 244.245L484.748 239.834L477.555 232.802C477.555 232.558 477.555 232.314 477.555 232.07H477.291L474.508 224.672V232.558C474.955 238.655 479.201 244.753 487.309 249.407C504.458 259.326 532.274 259.326 549.424 249.407C557.267 244.875 561.513 239.082 562.184 233.147V231.501C562.184 230.823 562.184 230.146 562.184 229.468L562.306 224.469Z",
    fill: "#2D36AD"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M559.278 224.326C559.44 230.423 555.458 236.683 547.31 241.378C531.339 250.606 505.432 250.606 489.462 241.378C481.334 236.704 477.27 230.565 477.473 224.448H474.466C474.365 231.013 478.652 237.598 487.328 242.618C504.477 252.516 532.294 252.516 549.443 242.618C558.119 237.598 562.386 231.033 562.305 224.468C561.289 224.265 560.293 223.797 559.278 224.326Z",
    fill: "#7990FC"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M518.375 248.573C508.255 248.774 498.253 246.381 489.319 241.622C481.395 237.049 477.128 230.952 477.128 224.448C477.128 217.944 481.537 212.253 489.319 207.72C505.351 198.452 531.42 198.472 547.451 207.72C555.112 212.131 559.399 218.045 559.643 224.326C559.887 230.606 555.579 237.029 547.451 241.622C538.51 246.381 528.501 248.774 518.375 248.573ZM518.375 201.338C508.355 201.132 498.45 203.497 489.604 208.208C482.065 212.558 477.859 218.37 477.758 224.468C477.656 230.565 481.821 236.663 489.604 241.155C505.473 250.321 531.298 250.321 547.167 241.155C554.949 236.663 559.155 230.687 558.993 224.366C558.83 218.045 554.644 212.537 547.167 208.228C538.315 203.511 528.403 201.138 518.375 201.338Z",
    fill: "#2D36AD"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M363.829 368.957L286.393 324.222L284.321 325.421L361.756 370.136L363.829 368.957Z",
    fill: "#7990FC"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M288.691 351.478H288.548C288.259 351.267 288.022 350.993 287.856 350.675C287.69 350.358 287.6 350.006 287.593 349.649V336.092C287.593 335.401 288.02 335.076 288.548 335.38H288.691C288.983 335.589 289.221 335.863 289.387 336.181C289.553 336.498 289.642 336.851 289.646 337.21V350.746C289.686 351.457 289.219 351.783 288.691 351.478Z",
    fill: "#242993"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M292.753 353.836H292.611C292.319 353.628 292.081 353.354 291.915 353.036C291.749 352.718 291.66 352.366 291.656 352.007V338.471C291.656 337.759 292.083 337.434 292.611 337.739H292.753C293.046 337.948 293.286 338.222 293.455 338.54C293.624 338.857 293.718 339.209 293.729 339.568V353.125C293.749 353.816 293.282 354.141 292.753 353.836Z",
    fill: "#242993"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M296.836 356.172H296.694C296.402 355.964 296.163 355.69 295.997 355.372C295.831 355.054 295.743 354.702 295.739 354.343V340.807C295.739 340.096 296.166 339.77 296.694 340.075H296.836C297.128 340.283 297.367 340.557 297.533 340.875C297.699 341.193 297.787 341.546 297.791 341.904V355.461C297.812 356.152 297.365 356.477 296.836 356.172Z",
    fill: "#242993"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M300.901 358.53H300.759C300.47 358.319 300.233 358.045 300.067 357.727C299.901 357.41 299.811 357.059 299.804 356.701V343.144C299.804 342.453 300.231 342.128 300.759 342.433H300.901C301.193 342.641 301.432 342.915 301.598 343.233C301.764 343.551 301.852 343.903 301.856 344.262V357.798C301.877 358.51 301.43 358.835 300.901 358.53Z",
    fill: "#242993"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M304.968 360.868H304.825C304.533 360.66 304.295 360.385 304.129 360.067C303.963 359.75 303.874 359.397 303.87 359.038V345.502C303.87 344.791 304.297 344.465 304.825 344.77H304.968C305.257 344.981 305.494 345.255 305.66 345.573C305.826 345.89 305.915 346.242 305.923 346.6V360.095C305.943 360.868 305.496 361.173 304.968 360.868Z",
    fill: "#242993"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M309.051 363.225H308.908C308.614 363.018 308.372 362.745 308.203 362.427C308.033 362.109 307.941 361.756 307.933 361.396V347.86C307.933 347.148 308.38 346.823 308.908 347.128H309.051C309.343 347.336 309.581 347.61 309.747 347.928C309.913 348.246 310.002 348.599 310.006 348.957V362.494C310.006 363.205 309.579 363.53 309.051 363.225Z",
    fill: "#242993"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M313.114 365.583H312.972C312.683 365.372 312.446 365.098 312.28 364.78C312.114 364.463 312.024 364.112 312.017 363.754V350.197C312.017 349.486 312.444 349.16 312.972 349.486H313.114C313.406 349.694 313.645 349.968 313.811 350.286C313.977 350.604 314.066 350.956 314.069 351.315V364.851C314.069 365.563 313.643 365.888 313.114 365.583Z",
    fill: "#242993"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M289.382 350.969H289.24C288.95 350.759 288.713 350.484 288.548 350.167C288.382 349.849 288.292 349.498 288.285 349.14V335.502C288.275 335.4 288.275 335.298 288.285 335.197C287.858 335.095 287.553 335.42 287.553 336.01V349.567C287.56 349.925 287.65 350.276 287.816 350.593C287.982 350.911 288.219 351.185 288.508 351.396H288.651C289.098 351.66 289.463 351.396 289.585 350.969H289.382Z",
    fill: "#404FCE"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M293.464 353.327H293.322C293.027 353.12 292.786 352.847 292.616 352.529C292.447 352.211 292.354 351.858 292.347 351.498V337.961C292.334 337.86 292.334 337.758 292.347 337.657C291.94 337.657 291.615 337.86 291.615 338.47V351.965C291.622 352.326 291.712 352.681 291.878 353.001C292.043 353.322 292.28 353.6 292.57 353.815H292.712C292.797 353.877 292.896 353.915 293 353.925C293.104 353.936 293.209 353.918 293.305 353.875C293.4 353.832 293.482 353.764 293.542 353.678C293.602 353.592 293.638 353.492 293.647 353.388L293.464 353.327Z",
    fill: "#404FCE"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M297.531 355.664H297.388C297.096 355.456 296.858 355.182 296.692 354.864C296.526 354.546 296.437 354.194 296.433 353.835V340.299C296.422 340.197 296.422 340.095 296.433 339.994C296.027 339.872 295.722 340.197 295.722 340.807V354.343C295.726 354.702 295.815 355.054 295.981 355.372C296.147 355.69 296.385 355.964 296.677 356.172H296.819C296.901 356.235 296.997 356.274 297.099 356.287C297.201 356.299 297.304 356.283 297.398 356.242C297.491 356.2 297.572 356.134 297.631 356.05C297.69 355.966 297.726 355.868 297.734 355.766L297.531 355.664Z",
    fill: "#404FCE"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M301.593 358.063H301.451C301.161 357.853 300.924 357.578 300.758 357.261C300.593 356.943 300.503 356.592 300.496 356.234V342.677C300.486 342.576 300.486 342.474 300.496 342.372C300.069 342.271 299.764 342.596 299.764 343.185V356.742C299.768 357.1 299.857 357.453 300.023 357.771C300.189 358.089 300.427 358.363 300.719 358.571H300.861C300.934 358.697 301.052 358.79 301.191 358.832C301.329 358.874 301.479 358.861 301.609 358.796C301.739 358.731 301.839 358.619 301.889 358.483C301.938 358.347 301.935 358.196 301.877 358.063H301.593Z",
    fill: "#404FCE"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M305.658 360.38H305.516C305.224 360.172 304.985 359.898 304.819 359.58C304.653 359.262 304.565 358.91 304.561 358.551V345.015C304.548 344.914 304.548 344.811 304.561 344.71C304.134 344.71 303.829 344.934 303.829 345.523V359.059C303.833 359.421 303.922 359.776 304.087 360.097C304.253 360.419 304.492 360.696 304.784 360.909H304.926C305.011 360.971 305.11 361.009 305.214 361.019C305.318 361.03 305.423 361.012 305.519 360.969C305.614 360.926 305.696 360.858 305.756 360.772C305.816 360.686 305.852 360.586 305.861 360.482L305.658 360.38Z",
    fill: "#404FCE"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M309.74 362.717H309.598C309.306 362.509 309.067 362.235 308.901 361.917C308.735 361.599 308.646 361.246 308.643 360.888V347.351C308.631 347.25 308.631 347.148 308.643 347.046C308.236 346.924 307.911 347.25 307.911 347.859V361.396C307.919 361.756 308.011 362.109 308.181 362.427C308.35 362.744 308.592 363.018 308.886 363.225H309.029C309.11 363.288 309.206 363.327 309.308 363.339C309.41 363.351 309.513 363.336 309.607 363.294C309.701 363.252 309.781 363.186 309.84 363.103C309.9 363.019 309.935 362.921 309.943 362.818L309.74 362.717Z",
    fill: "#404FCE"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M313.805 365.074H313.663C313.371 364.866 313.132 364.592 312.966 364.274C312.8 363.956 312.712 363.604 312.708 363.245V349.689C312.698 349.587 312.698 349.485 312.708 349.384C312.281 349.282 311.976 349.607 311.976 350.197V363.753C311.98 364.112 312.069 364.465 312.235 364.782C312.401 365.1 312.639 365.374 312.931 365.583H313.073C313.156 365.646 313.254 365.685 313.358 365.697C313.461 365.708 313.566 365.691 313.66 365.646C313.754 365.602 313.835 365.533 313.892 365.447C313.95 365.36 313.983 365.26 313.988 365.156L313.805 365.074Z",
    fill: "#404FCE"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M327.154 373.672H327.011C326.722 373.462 326.485 373.187 326.319 372.87C326.153 372.553 326.064 372.201 326.056 371.843V358.287C326.056 357.595 326.483 357.27 327.011 357.575H327.154C327.446 357.783 327.684 358.057 327.85 358.375C328.016 358.693 328.105 359.046 328.109 359.404V372.941C328.109 373.652 327.682 373.977 327.154 373.672Z",
    fill: "#242993"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M331.219 376.031L331.077 375.929C330.785 375.721 330.546 375.447 330.38 375.129C330.214 374.811 330.125 374.458 330.122 374.1V360.563C330.122 359.852 330.548 359.527 331.077 359.832H331.219C331.508 360.042 331.745 360.317 331.911 360.634C332.077 360.951 332.167 361.303 332.174 361.661V375.218C332.174 376.01 331.747 376.356 331.219 376.031Z",
    fill: "#242993"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M335.281 378.388H335.138C334.846 378.18 334.608 377.906 334.442 377.588C334.276 377.27 334.187 376.917 334.183 376.559V363.022C334.183 362.311 334.61 361.986 335.138 362.291H335.281C335.573 362.499 335.811 362.773 335.977 363.091C336.143 363.409 336.232 363.761 336.236 364.12V377.676C336.236 378.388 335.809 378.672 335.281 378.388Z",
    fill: "#242993"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M339.366 380.724H339.224C338.931 380.515 338.691 380.241 338.522 379.924C338.353 379.606 338.259 379.254 338.248 378.895V365.338C338.248 364.627 338.695 364.322 339.224 364.627H339.366C339.658 364.835 339.897 365.109 340.063 365.427C340.229 365.745 340.317 366.098 340.321 366.456V379.992C340.321 380.704 339.894 381.029 339.366 380.724Z",
    fill: "#242993"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M343.429 383.062H343.286C342.994 382.854 342.756 382.579 342.59 382.261C342.424 381.944 342.335 381.591 342.331 381.232V367.615C342.331 366.903 342.758 366.578 343.286 366.883H343.429C343.718 367.093 343.955 367.368 344.121 367.685C344.287 368.003 344.376 368.354 344.384 368.712V382.452C344.384 383.041 343.957 383.366 343.429 383.062Z",
    fill: "#242993"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M347.494 385.42H347.351C347.059 385.212 346.821 384.938 346.655 384.62C346.489 384.302 346.4 383.949 346.396 383.591V370.034C346.396 369.343 346.823 369.018 347.351 369.323H347.494C347.786 369.531 348.024 369.805 348.19 370.123C348.356 370.441 348.445 370.793 348.449 371.152V384.688C348.449 385.4 348.022 385.725 347.494 385.42Z",
    fill: "#242993"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M351.58 387.779H351.417C351.128 387.568 350.891 387.294 350.725 386.976C350.559 386.659 350.47 386.307 350.462 385.949V372.291C350.462 371.58 350.889 371.254 351.417 371.559H351.58C351.872 371.767 352.111 372.042 352.277 372.359C352.443 372.677 352.531 373.03 352.535 373.389V386.925C352.535 387.758 352.108 388.083 351.58 387.779Z",
    fill: "#242993"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M327.845 373.164H327.703C327.413 372.954 327.176 372.679 327.011 372.362C326.845 372.044 326.755 371.693 326.748 371.335V357.778C326.738 357.677 326.738 357.575 326.748 357.473C326.321 357.473 326.017 357.697 326.017 358.286V371.843C326.024 372.201 326.114 372.552 326.279 372.87C326.445 373.187 326.682 373.462 326.972 373.672H327.114C327.196 373.735 327.295 373.775 327.398 373.786C327.502 373.797 327.606 373.78 327.7 373.736C327.795 373.692 327.875 373.623 327.933 373.536C327.991 373.45 328.024 373.349 328.028 373.245L327.845 373.164Z",
    fill: "#404FCE"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M331.909 375.502H331.767C331.475 375.294 331.236 375.02 331.07 374.702C330.905 374.384 330.816 374.031 330.812 373.673V360.096C330.8 359.994 330.8 359.892 330.812 359.791C330.385 359.689 330.081 359.994 330.081 360.604V374.14C330.088 374.501 330.177 374.855 330.343 375.176C330.509 375.497 330.746 375.775 331.036 375.99H331.178C331.26 376.053 331.359 376.092 331.462 376.104C331.566 376.115 331.67 376.098 331.764 376.054C331.859 376.01 331.939 375.941 331.997 375.854C332.055 375.768 332.088 375.667 332.092 375.563C332.029 375.551 331.967 375.531 331.909 375.502Z",
    fill: "#404FCE"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M335.991 377.86H335.849C335.551 377.657 335.307 377.384 335.137 377.066C334.967 376.747 334.877 376.392 334.874 376.031V362.495C334.861 362.393 334.861 362.291 334.874 362.19C334.467 362.068 334.142 362.393 334.142 363.003V376.539C334.146 376.898 334.235 377.25 334.401 377.568C334.567 377.886 334.805 378.16 335.097 378.368H335.24C335.323 378.43 335.42 378.468 335.523 378.479C335.626 378.491 335.729 378.475 335.824 378.434C335.919 378.393 336.001 378.328 336.062 378.245C336.124 378.162 336.162 378.064 336.174 377.962L335.991 377.86Z",
    fill: "#404FCE"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M340.057 380.217H339.915C339.625 380.006 339.388 379.732 339.223 379.414C339.057 379.097 338.967 378.745 338.96 378.387V364.831C338.95 364.729 338.95 364.627 338.96 364.526C338.554 364.526 338.229 364.749 338.229 365.339V378.895C338.236 379.255 338.329 379.609 338.498 379.926C338.668 380.244 338.909 380.518 339.204 380.725H339.346C339.429 380.788 339.527 380.827 339.63 380.839C339.734 380.85 339.838 380.833 339.933 380.789C340.027 380.745 340.107 380.676 340.165 380.589C340.223 380.503 340.256 380.402 340.26 380.298L340.057 380.217Z",
    fill: "#404FCE"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M344.119 382.574L343.977 382.473C343.685 382.265 343.446 381.991 343.28 381.673C343.114 381.355 343.026 381.002 343.022 380.644V367.107C343.009 367.006 343.009 366.904 343.022 366.802C342.595 366.701 342.29 367.006 342.29 367.615V381.152C342.294 381.513 342.383 381.869 342.549 382.19C342.714 382.511 342.953 382.789 343.245 383.001H343.388C343.47 383.065 343.569 383.104 343.672 383.115C343.775 383.127 343.88 383.109 343.974 383.065C344.068 383.021 344.149 382.952 344.207 382.866C344.264 382.779 344.297 382.678 344.302 382.574H344.119Z",
    fill: "#404FCE"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M348.185 384.912H348.043C347.751 384.704 347.512 384.43 347.346 384.112C347.18 383.794 347.092 383.442 347.088 383.083V369.547C347.075 369.445 347.075 369.343 347.088 369.242C346.661 369.12 346.356 369.445 346.356 370.055V383.591C346.36 383.95 346.449 384.302 346.615 384.62C346.781 384.938 347.019 385.212 347.311 385.42H347.454C347.537 385.482 347.634 385.52 347.737 385.531C347.84 385.543 347.943 385.527 348.038 385.486C348.133 385.445 348.215 385.38 348.276 385.297C348.338 385.214 348.376 385.116 348.388 385.014L348.185 384.912Z",
    fill: "#404FCE"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M352.269 387.27H352.127C351.837 387.059 351.6 386.785 351.435 386.467C351.269 386.15 351.179 385.798 351.172 385.44V371.884C351.162 371.782 351.162 371.68 351.172 371.579C350.765 371.477 350.44 371.802 350.44 372.392V385.948C350.444 386.307 350.533 386.66 350.699 386.978C350.865 387.295 351.103 387.57 351.395 387.778H351.558C351.641 387.841 351.739 387.88 351.842 387.892C351.946 387.903 352.05 387.886 352.144 387.842C352.239 387.798 352.319 387.729 352.377 387.642C352.435 387.556 352.468 387.455 352.472 387.351L352.269 387.27Z",
    fill: "#404FCE"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M418.428 369.547H418.57C418.862 369.339 419.101 369.064 419.267 368.746C419.433 368.429 419.522 368.076 419.526 367.717V360.705C419.526 359.994 419.099 359.669 418.57 359.974H418.428C418.139 360.184 417.902 360.459 417.736 360.776C417.57 361.093 417.48 361.445 417.473 361.803V368.815C417.473 369.526 417.9 369.851 418.428 369.547Z",
    fill: "#16237D"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M414.342 371.904H414.484C414.777 371.691 415.017 371.413 415.186 371.092C415.355 370.772 415.449 370.417 415.46 370.055V363.063C415.46 362.352 415.013 362.026 414.484 362.331H414.342C414.05 362.539 413.812 362.814 413.646 363.131C413.48 363.449 413.391 363.802 413.387 364.161V371.173C413.387 371.884 413.814 372.29 414.342 371.904Z",
    fill: "#16237D"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M410.28 374.323H410.423C410.715 374.115 410.953 373.841 411.119 373.523C411.285 373.205 411.374 372.852 411.378 372.494V365.481C411.378 364.77 410.951 364.445 410.423 364.77H410.28C409.988 364.978 409.75 365.252 409.584 365.57C409.418 365.888 409.329 366.241 409.325 366.599V373.611C409.325 374.323 409.752 374.546 410.28 374.323Z",
    fill: "#16237D"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M406.214 376.599H406.357C406.646 376.389 406.883 376.114 407.049 375.797C407.215 375.479 407.305 375.128 407.312 374.77V367.758C407.312 367.046 406.885 366.721 406.357 367.026H406.214C405.925 367.236 405.688 367.511 405.522 367.828C405.356 368.146 405.266 368.497 405.259 368.855V375.867C405.259 376.579 405.686 376.904 406.214 376.599Z",
    fill: "#16237D"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M402.153 378.937H402.295C402.587 378.729 402.826 378.455 402.992 378.137C403.158 377.819 403.246 377.466 403.25 377.108V370.096C403.25 369.405 402.823 369.079 402.295 369.384H402.153C401.858 369.591 401.617 369.865 401.447 370.182C401.278 370.5 401.185 370.853 401.178 371.213V378.226C401.178 378.937 401.625 379.262 402.153 378.937Z",
    fill: "#16237D"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M398.068 381.295H398.21C398.502 381.087 398.74 380.813 398.906 380.495C399.072 380.177 399.161 379.824 399.165 379.466V372.291C399.165 371.58 398.738 371.254 398.21 371.559H398.068C397.777 371.774 397.54 372.052 397.375 372.373C397.209 372.694 397.12 373.048 397.113 373.409V380.401C397.113 381.275 397.539 381.6 398.068 381.295Z",
    fill: "#16237D"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M394.005 383.651H394.147C394.436 383.441 394.673 383.166 394.839 382.849C395.005 382.531 395.095 382.18 395.102 381.822V374.729C395.102 374.017 394.675 373.692 394.147 373.997H394.005C393.713 374.205 393.474 374.479 393.308 374.797C393.142 375.115 393.053 375.468 393.05 375.826V382.838C393.05 383.631 393.476 383.956 394.005 383.651Z",
    fill: "#16237D"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M417.696 369.039H417.839C418.128 368.828 418.365 368.554 418.531 368.236C418.697 367.919 418.787 367.567 418.794 367.209V360.096C418.806 359.994 418.806 359.892 418.794 359.791C419.22 359.689 419.525 359.994 419.525 360.604V367.616C419.521 367.974 419.433 368.327 419.267 368.645C419.101 368.963 418.862 369.237 418.57 369.445H418.428C417.981 369.709 417.615 369.445 417.493 369.018L417.696 369.039Z",
    fill: "#404FCE"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M413.63 371.396H413.773C414.063 371.181 414.3 370.903 414.465 370.582C414.631 370.261 414.72 369.907 414.728 369.546V362.534C414.738 362.433 414.738 362.331 414.728 362.229C415.134 362.229 415.459 362.453 415.459 363.062V370.075C415.448 370.434 415.354 370.786 415.185 371.103C415.016 371.42 414.776 371.694 414.484 371.904H414.341C414.259 371.967 414.161 372.006 414.057 372.018C413.954 372.029 413.849 372.012 413.755 371.968C413.661 371.924 413.58 371.855 413.522 371.768C413.465 371.682 413.432 371.581 413.427 371.477L413.63 371.396Z",
    fill: "#404FCE"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M409.568 373.733H409.71C410.002 373.525 410.241 373.251 410.407 372.933C410.573 372.615 410.662 372.263 410.665 371.904V364.892C410.675 364.791 410.675 364.688 410.665 364.587C411.092 364.587 411.397 364.811 411.397 365.4V372.29C411.393 372.649 411.305 373.001 411.139 373.319C410.973 373.637 410.734 373.911 410.442 374.119H410.3C410.221 374.19 410.123 374.236 410.019 374.252C409.915 374.269 409.808 374.255 409.711 374.212C409.615 374.169 409.532 374.099 409.475 374.01C409.417 373.922 409.386 373.819 409.385 373.713L409.568 373.733Z",
    fill: "#404FCE"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M405.505 376.091H405.647C405.939 375.883 406.178 375.608 406.343 375.29C406.509 374.973 406.598 374.62 406.602 374.261V367.249C406.614 367.148 406.614 367.046 406.602 366.944C407.029 366.843 407.333 367.148 407.333 367.757V374.77C407.329 375.128 407.241 375.481 407.075 375.799C406.909 376.116 406.67 376.391 406.378 376.599H406.236C405.789 376.863 405.423 376.599 405.301 376.172C405.374 376.158 405.443 376.131 405.505 376.091Z",
    fill: "#404FCE"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M401.44 378.389H401.583C401.877 378.177 402.119 377.9 402.288 377.579C402.458 377.258 402.55 376.902 402.558 376.539V369.547C402.569 369.439 402.569 369.33 402.558 369.222C402.964 369.222 403.289 369.446 403.289 370.056V377.068C403.282 377.426 403.192 377.777 403.027 378.095C402.861 378.412 402.624 378.687 402.334 378.897H402.192C402.108 378.959 402.008 378.997 401.904 379.007C401.8 379.018 401.695 379.001 401.6 378.957C401.505 378.914 401.423 378.846 401.363 378.76C401.302 378.674 401.266 378.574 401.257 378.47L401.44 378.389Z",
    fill: "#404FCE"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M397.377 380.787H397.519C397.811 380.578 398.05 380.304 398.215 379.986C398.381 379.669 398.47 379.316 398.474 378.957V371.945C398.484 371.844 398.484 371.742 398.474 371.64C398.88 371.64 399.185 371.864 399.185 372.453V379.465C399.181 379.824 399.093 380.177 398.927 380.495C398.761 380.812 398.522 381.087 398.23 381.295H398.088C398.009 381.365 397.912 381.411 397.807 381.428C397.703 381.444 397.596 381.43 397.499 381.387C397.403 381.344 397.321 381.274 397.263 381.186C397.205 381.097 397.174 380.994 397.173 380.888C397.248 380.869 397.317 380.834 397.377 380.787Z",
    fill: "#404FCE"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M393.314 383.143H393.457C393.749 382.935 393.987 382.661 394.153 382.343C394.319 382.025 394.408 381.672 394.412 381.314V374.322C394.424 374.221 394.424 374.118 394.412 374.017C394.838 373.915 395.143 374.22 395.143 374.83V381.842C395.139 382.201 395.051 382.553 394.885 382.871C394.719 383.189 394.48 383.463 394.188 383.671H394.046C393.963 383.735 393.865 383.774 393.761 383.785C393.658 383.797 393.553 383.779 393.459 383.735C393.365 383.691 393.285 383.622 393.227 383.536C393.169 383.449 393.136 383.349 393.131 383.245C393.198 383.221 393.26 383.187 393.314 383.143Z",
    fill: "#404FCE"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M468.493 340.624H468.636C468.928 340.416 469.166 340.142 469.332 339.824C469.498 339.506 469.587 339.154 469.591 338.795V331.641C469.591 330.929 469.164 330.604 468.636 330.909H468.493C468.204 331.119 467.967 331.394 467.801 331.711C467.635 332.029 467.545 332.38 467.538 332.738V339.75C467.498 340.604 467.924 340.929 468.493 340.624Z",
    fill: "#16237D"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M464.428 342.981L464.571 342.88C464.863 342.672 465.101 342.398 465.267 342.08C465.433 341.762 465.522 341.409 465.525 341.051V334.038C465.525 333.347 465.099 333.022 464.571 333.327H464.428C464.136 333.535 463.898 333.809 463.732 334.127C463.566 334.445 463.477 334.798 463.473 335.156V342.168C463.433 342.961 463.859 343.286 464.428 342.981Z",
    fill: "#16237D"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M460.366 345.32H460.509C460.807 345.117 461.051 344.844 461.221 344.525C461.391 344.207 461.481 343.852 461.484 343.491V336.479C461.484 335.767 461.057 335.442 460.509 335.747L460.366 335.707C460.074 335.915 459.836 336.189 459.67 336.507C459.504 336.825 459.415 337.177 459.412 337.536V344.548C459.351 345.3 459.777 345.625 460.366 345.32Z",
    fill: "#16237D"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M456.301 347.678H456.444C456.733 347.467 456.97 347.193 457.136 346.875C457.302 346.558 457.392 346.207 457.399 345.849V338.755C457.399 338.044 456.972 337.719 456.444 338.024H456.301C456.012 338.234 455.775 338.509 455.609 338.826C455.443 339.143 455.354 339.495 455.347 339.853V346.865C455.286 347.658 455.712 347.901 456.301 347.678Z",
    fill: "#16237D"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M452.238 349.933H452.381C452.673 349.725 452.911 349.451 453.077 349.133C453.243 348.815 453.332 348.463 453.336 348.104V341.092C453.336 340.401 452.909 340.076 452.381 340.381H452.238C451.946 340.589 451.708 340.863 451.542 341.181C451.376 341.499 451.287 341.851 451.283 342.21V349.222C451.223 349.933 451.649 350.32 452.238 349.933Z",
    fill: "#16237D"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M448.175 352.373H448.317C448.609 352.164 448.847 351.89 449.013 351.572C449.179 351.255 449.268 350.902 449.272 350.543V343.531C449.272 342.82 448.845 342.495 448.317 342.8H448.175C447.88 343.011 447.638 343.288 447.469 343.609C447.299 343.93 447.207 344.286 447.199 344.649V351.641C447.138 352.352 447.585 352.677 448.175 352.373Z",
    fill: "#16237D"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M444.11 354.73H444.253C444.542 354.52 444.779 354.245 444.945 353.928C445.111 353.61 445.201 353.259 445.208 352.901V345.869C445.208 345.157 444.781 344.832 444.253 345.137H444.11C443.818 345.345 443.58 345.619 443.414 345.937C443.248 346.255 443.159 346.608 443.155 346.966V353.999C443.074 354.71 443.501 355.035 444.11 354.73Z",
    fill: "#16237D"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M467.762 340.115H467.904C468.194 339.905 468.431 339.63 468.596 339.313C468.762 338.995 468.852 338.644 468.859 338.286V331.274C468.871 331.173 468.871 331.07 468.859 330.969C469.286 330.969 469.59 331.172 469.59 331.782V338.794C469.586 339.153 469.498 339.505 469.332 339.823C469.166 340.141 468.927 340.415 468.635 340.623H468.493C468.411 340.687 468.312 340.726 468.209 340.737C468.105 340.749 468.001 340.731 467.907 340.687C467.812 340.643 467.732 340.574 467.674 340.488C467.616 340.401 467.583 340.3 467.579 340.196L467.762 340.115Z",
    fill: "#404FCE"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M463.698 342.473L463.84 342.372C464.132 342.164 464.371 341.89 464.537 341.572C464.703 341.254 464.791 340.901 464.795 340.543V333.531C464.805 333.429 464.805 333.327 464.795 333.226C465.222 333.124 465.527 333.449 465.527 334.059V341.051C465.523 341.412 465.434 341.768 465.269 342.089C465.103 342.41 464.864 342.688 464.572 342.9H464.43C464.345 342.962 464.246 343 464.142 343.011C464.038 343.021 463.933 343.004 463.837 342.96C463.742 342.917 463.66 342.849 463.6 342.763C463.54 342.678 463.504 342.578 463.495 342.473H463.698Z",
    fill: "#404FCE"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M459.613 344.811H459.755C460.047 344.603 460.286 344.329 460.452 344.011C460.618 343.693 460.706 343.34 460.71 342.982V335.97C460.72 335.868 460.72 335.766 460.71 335.665C461.117 335.563 461.442 335.889 461.442 336.478V343.49C461.439 343.851 461.349 344.206 461.179 344.525C461.009 344.843 460.765 345.116 460.466 345.319H460.324C460.243 345.382 460.146 345.421 460.045 345.433C459.943 345.446 459.84 345.43 459.746 345.388C459.652 345.347 459.572 345.281 459.512 345.197C459.453 345.113 459.418 345.015 459.41 344.913L459.613 344.811Z",
    fill: "#404FCE"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M455.549 347.168H455.691C455.981 346.958 456.218 346.683 456.383 346.366C456.549 346.049 456.639 345.697 456.646 345.339V338.327C456.658 338.226 456.658 338.123 456.646 338.022C457.073 338.022 457.377 338.225 457.377 338.835V345.868C457.374 346.226 457.285 346.579 457.119 346.897C456.953 347.215 456.714 347.489 456.422 347.697H456.28C456.198 347.76 456.099 347.8 455.996 347.811C455.892 347.822 455.788 347.805 455.694 347.761C455.599 347.717 455.519 347.648 455.461 347.561C455.403 347.475 455.37 347.374 455.366 347.27L455.549 347.168Z",
    fill: "#404FCE"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M451.486 349.526H451.628C451.919 349.312 452.156 349.033 452.321 348.713C452.487 348.392 452.576 348.038 452.583 347.677V340.685C452.595 340.577 452.595 340.468 452.583 340.36C453.01 340.258 453.315 340.583 453.315 341.193V348.205C453.308 348.563 453.218 348.915 453.052 349.232C452.887 349.549 452.65 349.824 452.36 350.034H452.218C452.133 350.096 452.034 350.134 451.93 350.145C451.826 350.155 451.721 350.138 451.625 350.095C451.53 350.051 451.448 349.983 451.388 349.897C451.328 349.812 451.292 349.712 451.283 349.608L451.486 349.526Z",
    fill: "#404FCE"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M447.403 351.965H447.545C447.84 351.758 448.081 351.485 448.251 351.167C448.42 350.849 448.513 350.496 448.52 350.136V343.124C448.53 343.023 448.53 342.921 448.52 342.819C448.927 342.819 449.252 343.043 449.252 343.632V350.644C449.248 351.003 449.159 351.355 448.993 351.673C448.827 351.991 448.589 352.265 448.297 352.474H448.155C448.074 352.542 447.975 352.586 447.87 352.601C447.765 352.617 447.658 352.602 447.561 352.56C447.464 352.518 447.381 352.449 447.32 352.362C447.26 352.275 447.225 352.173 447.22 352.067L447.403 351.965Z",
    fill: "#404FCE"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M443.338 354.221H443.481C443.773 354.013 444.011 353.739 444.177 353.421C444.343 353.103 444.432 352.751 444.435 352.392V345.38C444.447 345.279 444.447 345.176 444.435 345.075C444.842 345.075 445.147 345.278 445.147 345.888V352.9C445.143 353.259 445.054 353.611 444.888 353.929C444.722 354.247 444.484 354.521 444.192 354.729H444.049C443.967 354.793 443.869 354.832 443.765 354.843C443.662 354.855 443.557 354.837 443.463 354.793C443.369 354.749 443.288 354.68 443.23 354.594C443.173 354.507 443.14 354.407 443.135 354.303C443.208 354.291 443.277 354.263 443.338 354.221Z",
    fill: "#404FCE"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M518.477 311.702H518.62C518.909 311.491 519.146 311.217 519.312 310.899C519.478 310.582 519.568 310.231 519.575 309.873V302.779C519.575 302.068 519.148 301.743 518.62 302.047H518.477C518.188 302.258 517.951 302.532 517.785 302.85C517.62 303.167 517.53 303.519 517.523 303.877V310.889C517.523 311.681 517.949 312.007 518.477 311.702Z",
    fill: "#16237D"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M514.415 314.06H514.557C514.849 313.852 515.088 313.577 515.253 313.259C515.419 312.942 515.508 312.589 515.512 312.23V305.218C515.512 304.527 515.085 304.202 514.557 304.507H514.415C514.123 304.715 513.884 304.989 513.718 305.307C513.552 305.625 513.464 305.978 513.46 306.336V313.348C513.46 314.039 513.886 314.364 514.415 314.06Z",
    fill: "#16237D"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M510.349 316.398H510.492C510.784 316.19 511.022 315.915 511.188 315.598C511.354 315.28 511.443 314.927 511.447 314.568V307.556C511.447 306.845 511.02 306.52 510.492 306.825L510.349 306.926C510.058 307.134 509.819 307.409 509.653 307.726C509.487 308.044 509.398 308.397 509.395 308.756V315.768C509.395 316.377 509.821 316.703 510.349 316.398Z",
    fill: "#16237D"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M506.267 318.754H506.429C506.719 318.544 506.956 318.269 507.122 317.952C507.287 317.635 507.377 317.283 507.384 316.925V309.913C507.384 309.202 506.957 308.877 506.429 309.181H506.267C505.977 309.392 505.74 309.666 505.574 309.984C505.409 310.301 505.319 310.653 505.312 311.011V318.023C505.312 318.734 505.738 319.059 506.267 318.754Z",
    fill: "#16237D"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M502.202 321.092H502.344C502.636 320.884 502.875 320.61 503.041 320.292C503.207 319.974 503.295 319.622 503.299 319.263V312.251C503.299 311.56 502.872 311.235 502.344 311.54H502.202C501.91 311.748 501.671 312.022 501.505 312.34C501.339 312.658 501.251 313.01 501.247 313.369V320.381C501.247 321.092 501.673 321.478 502.202 321.092Z",
    fill: "#16237D"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M498.139 323.51H498.281C498.573 323.302 498.812 323.028 498.978 322.71C499.144 322.392 499.232 322.04 499.236 321.681V314.669C499.236 313.958 498.809 313.632 498.281 313.937H498.139C497.849 314.148 497.612 314.422 497.446 314.74C497.281 315.057 497.191 315.409 497.184 315.767V322.779C497.184 323.51 497.611 323.754 498.139 323.51Z",
    fill: "#16237D"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M494.075 325.808H494.217C494.507 325.598 494.744 325.323 494.91 325.006C495.075 324.689 495.165 324.337 495.172 323.979V316.967C495.172 316.256 494.746 315.931 494.217 316.235H494.075C493.781 316.443 493.539 316.716 493.369 317.034C493.2 317.351 493.108 317.705 493.1 318.065V325.077C493.1 325.788 493.547 326.113 494.075 325.808Z",
    fill: "#16237D"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M517.787 311.194H517.929C518.219 310.984 518.455 310.709 518.621 310.391C518.787 310.074 518.877 309.723 518.884 309.365V302.353C518.895 302.251 518.895 302.149 518.884 302.048C519.29 301.946 519.595 302.251 519.595 302.861V309.873C519.588 310.231 519.498 310.582 519.332 310.9C519.167 311.217 518.93 311.492 518.64 311.702H518.498C518.415 311.765 518.317 311.805 518.213 311.816C518.11 311.827 518.006 311.81 517.911 311.766C517.817 311.722 517.737 311.653 517.679 311.566C517.621 311.48 517.588 311.379 517.583 311.275L517.787 311.194Z",
    fill: "#404FCE"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M513.725 313.552H513.867C514.159 313.344 514.397 313.07 514.563 312.752C514.729 312.434 514.818 312.081 514.822 311.723V304.609C514.832 304.508 514.832 304.406 514.822 304.304C515.248 304.203 515.553 304.528 515.553 305.117V312.129C515.546 312.49 515.456 312.845 515.291 313.165C515.125 313.486 514.888 313.764 514.598 313.979H514.456C514.373 314.042 514.275 314.082 514.172 314.093C514.068 314.104 513.964 314.087 513.869 314.043C513.775 313.999 513.695 313.93 513.637 313.843C513.579 313.757 513.546 313.656 513.542 313.552H513.725Z",
    fill: "#404FCE"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M509.66 315.889H509.802C510.094 315.681 510.333 315.407 510.499 315.089C510.665 314.771 510.753 314.418 510.757 314.06V307.048C510.767 306.946 510.767 306.844 510.757 306.743C511.184 306.641 511.488 306.966 511.488 307.556V314.568C511.485 314.927 511.396 315.279 511.23 315.597C511.064 315.915 510.826 316.189 510.534 316.397H510.391C510.308 316.458 510.21 316.497 510.108 316.508C510.005 316.52 509.902 316.504 509.807 316.463C509.712 316.422 509.63 316.357 509.569 316.274C509.507 316.191 509.469 316.093 509.457 315.991L509.66 315.889Z",
    fill: "#404FCE"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M505.573 318.246H505.715C506.005 318.035 506.241 317.76 506.407 317.443C506.573 317.126 506.663 316.774 506.67 316.416V309.282C506.681 309.181 506.681 309.079 506.67 308.977C507.076 308.876 507.401 309.181 507.401 309.79V316.802C507.397 317.161 507.309 317.514 507.143 317.832C506.977 318.149 506.738 318.424 506.446 318.632H506.284C506.201 318.695 506.103 318.734 505.999 318.746C505.896 318.757 505.792 318.74 505.697 318.696C505.603 318.652 505.523 318.583 505.465 318.496C505.407 318.41 505.374 318.309 505.369 318.205L505.573 318.246Z",
    fill: "#404FCE"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M501.512 320.604H501.654C501.946 320.396 502.184 320.122 502.35 319.804C502.516 319.486 502.605 319.133 502.609 318.775V311.763C502.619 311.661 502.619 311.559 502.609 311.458C503.035 311.356 503.34 311.681 503.34 312.291V319.283C503.336 319.644 503.248 320 503.082 320.321C502.916 320.642 502.678 320.92 502.385 321.132H502.243C502.16 321.196 502.062 321.235 501.959 321.246C501.855 321.258 501.751 321.24 501.656 321.196C501.562 321.152 501.482 321.083 501.424 320.997C501.366 320.91 501.333 320.81 501.329 320.706L501.512 320.604Z",
    fill: "#404FCE"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M497.449 322.942H497.591C497.883 322.734 498.122 322.46 498.287 322.142C498.453 321.824 498.542 321.471 498.546 321.113V314.101C498.556 313.999 498.556 313.897 498.546 313.796C498.973 313.694 499.277 314.019 499.277 314.609V321.479C499.274 321.837 499.185 322.19 499.019 322.508C498.853 322.826 498.614 323.1 498.322 323.308H498.18C498.099 323.37 498.002 323.41 497.901 323.422C497.799 323.434 497.696 323.419 497.602 323.377C497.508 323.335 497.428 323.269 497.368 323.185C497.309 323.102 497.274 323.004 497.266 322.901L497.449 322.942Z",
    fill: "#404FCE"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M493.362 325.3H493.505C493.797 325.09 494.037 324.816 494.206 324.499C494.375 324.182 494.469 323.83 494.48 323.47V316.458C494.493 316.357 494.493 316.255 494.48 316.154C494.886 316.052 495.212 316.357 495.212 316.967V323.979C495.208 324.337 495.119 324.69 494.953 325.008C494.787 325.326 494.548 325.6 494.256 325.808H494.114C493.667 326.072 493.302 325.808 493.18 325.381L493.362 325.3Z",
    fill: "#404FCE"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M568.523 282.861H568.665C568.955 282.65 569.192 282.376 569.358 282.058C569.523 281.741 569.613 281.389 569.62 281.031V274.019C569.62 273.308 569.194 272.983 568.665 273.288H568.523C568.233 273.498 567.996 273.773 567.831 274.09C567.665 274.407 567.575 274.759 567.568 275.117V282.129C567.568 282.861 568.056 283.084 568.523 282.861Z",
    fill: "#16237D"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M564.439 285.117H564.581C564.876 284.91 565.118 284.637 565.287 284.319C565.456 284.001 565.549 283.648 565.557 283.288V276.276C565.557 275.585 565.11 275.26 564.581 275.564H564.439C564.147 275.773 563.908 276.047 563.742 276.365C563.576 276.682 563.488 277.035 563.484 277.394V284.406C563.484 285.117 563.992 285.442 564.439 285.117Z",
    fill: "#16237D"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M560.375 287.475H560.517C560.809 287.267 561.048 286.993 561.214 286.675C561.38 286.357 561.469 286.005 561.472 285.646V278.634C561.472 277.923 561.046 277.597 560.517 277.902H560.375C560.085 278.117 559.848 278.395 559.683 278.716C559.517 279.037 559.427 279.391 559.42 279.752V286.744C559.42 287.455 559.928 287.78 560.375 287.475Z",
    fill: "#16237D"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M556.312 289.833H556.454C556.744 289.623 556.981 289.348 557.147 289.03C557.313 288.713 557.402 288.362 557.41 288.004V280.829C557.41 280.118 556.983 279.792 556.454 280.097H556.312C556.02 280.305 555.782 280.58 555.616 280.897C555.45 281.215 555.361 281.568 555.357 281.926V288.939C555.357 289.813 555.865 290.138 556.312 289.833Z",
    fill: "#16237D"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M552.226 292.17H552.389C552.681 291.961 552.92 291.687 553.086 291.369C553.251 291.052 553.34 290.699 553.344 290.34V283.328C553.344 282.637 552.917 282.312 552.389 282.617H552.226C551.934 282.825 551.696 283.099 551.53 283.417C551.364 283.735 551.275 284.088 551.271 284.446V291.458C551.271 292.149 551.8 292.474 552.226 292.17Z",
    fill: "#16237D"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M548.163 294.527H548.306C548.598 294.319 548.836 294.045 549.002 293.727C549.168 293.409 549.257 293.057 549.261 292.698V285.686C549.261 284.975 548.834 284.649 548.306 284.954H548.163C547.874 285.165 547.637 285.439 547.471 285.757C547.305 286.074 547.215 286.426 547.208 286.784V293.796C547.208 294.507 547.737 294.832 548.163 294.527Z",
    fill: "#16237D"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M544.1 296.886H544.243C544.532 296.675 544.769 296.401 544.935 296.083C545.101 295.766 545.191 295.414 545.198 295.056V288.044C545.198 287.333 544.771 287.008 544.243 287.313H544.1C543.808 287.521 543.57 287.795 543.404 288.113C543.238 288.431 543.149 288.783 543.145 289.142V296.154C543.145 296.865 543.674 297.191 544.1 296.886Z",
    fill: "#16237D"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M567.812 282.271H567.954C568.25 282.065 568.493 281.792 568.662 281.474C568.832 281.156 568.923 280.802 568.93 280.442V273.43C568.942 273.329 568.942 273.226 568.93 273.125C569.336 273.125 569.661 273.328 569.661 273.938V280.828C569.654 281.186 569.564 281.538 569.398 281.855C569.233 282.172 568.996 282.447 568.706 282.657H568.564C568.479 282.719 568.38 282.757 568.276 282.768C568.172 282.778 568.067 282.761 567.972 282.717C567.876 282.674 567.795 282.606 567.734 282.52C567.674 282.435 567.638 282.335 567.629 282.231L567.812 282.271Z",
    fill: "#404FCE"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M563.749 284.61H563.892C564.184 284.402 564.422 284.128 564.588 283.81C564.754 283.492 564.843 283.139 564.846 282.781V275.768C564.857 275.667 564.857 275.565 564.846 275.464C565.253 275.464 565.578 275.687 565.578 276.277V283.289C565.57 283.649 565.478 284.002 565.308 284.32C565.139 284.637 564.897 284.911 564.603 285.118L564.46 285.22C564.378 285.283 564.279 285.322 564.176 285.334C564.073 285.345 563.968 285.327 563.874 285.283C563.78 285.239 563.699 285.17 563.641 285.084C563.584 284.997 563.551 284.897 563.546 284.793C563.628 284.75 563.698 284.687 563.749 284.61Z",
    fill: "#404FCE"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M559.683 286.926H559.825C560.117 286.718 560.356 286.444 560.522 286.126C560.688 285.808 560.776 285.455 560.78 285.097V278.085C560.791 277.983 560.791 277.881 560.78 277.78C561.207 277.78 561.512 278.003 561.512 278.593V285.605C561.508 285.963 561.419 286.316 561.253 286.634C561.087 286.952 560.849 287.226 560.557 287.434H560.414C560.333 287.497 560.237 287.536 560.135 287.548C560.033 287.56 559.93 287.545 559.836 287.503C559.743 287.462 559.662 287.395 559.603 287.312C559.544 287.228 559.508 287.13 559.5 287.028L559.683 286.926Z",
    fill: "#404FCE"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M555.621 289.324H555.764C556.053 289.114 556.29 288.839 556.456 288.522C556.622 288.204 556.711 287.853 556.718 287.495V280.483C556.731 280.382 556.731 280.279 556.718 280.178C557.145 280.178 557.45 280.381 557.45 280.991V288.003C557.443 288.361 557.353 288.713 557.187 289.03C557.022 289.347 556.785 289.622 556.495 289.832H556.353C555.906 290.097 555.54 289.832 555.418 289.405L555.621 289.324Z",
    fill: "#404FCE"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M551.535 291.682L551.678 291.58C551.97 291.372 552.208 291.098 552.374 290.78C552.54 290.462 552.629 290.109 552.633 289.751V282.739C552.643 282.637 552.643 282.535 552.633 282.434C553.039 282.434 553.364 282.657 553.364 283.247V290.259C553.357 290.62 553.267 290.974 553.102 291.295C552.936 291.615 552.699 291.894 552.409 292.108H552.246C552.164 292.172 552.066 292.211 551.962 292.222C551.859 292.234 551.754 292.216 551.66 292.172C551.566 292.128 551.485 292.059 551.427 291.973C551.37 291.886 551.337 291.786 551.332 291.682H551.535Z",
    fill: "#404FCE"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M547.474 294.019H547.616C547.908 293.811 548.147 293.537 548.313 293.219C548.479 292.901 548.567 292.549 548.571 292.19V285.097C548.581 284.995 548.581 284.893 548.571 284.792C548.998 284.792 549.303 285.015 549.303 285.605V292.617C549.299 292.975 549.21 293.328 549.044 293.646C548.878 293.964 548.64 294.238 548.348 294.446H548.206C548.124 294.509 548.028 294.548 547.926 294.56C547.824 294.572 547.721 294.557 547.627 294.515C547.534 294.474 547.453 294.407 547.394 294.324C547.335 294.24 547.299 294.142 547.291 294.04L547.474 294.019Z",
    fill: "#404FCE"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M543.411 296.377H543.554C543.843 296.167 544.08 295.892 544.246 295.575C544.411 295.258 544.501 294.906 544.508 294.548V287.536C544.521 287.435 544.521 287.333 544.508 287.231C544.935 287.13 545.24 287.435 545.24 288.044V295.056C545.236 295.415 545.148 295.768 544.982 296.085C544.816 296.403 544.577 296.677 544.285 296.886H544.143C544.06 296.949 543.962 296.988 543.858 297C543.755 297.011 543.651 296.994 543.556 296.95C543.462 296.906 543.382 296.837 543.324 296.75C543.266 296.663 543.233 296.563 543.228 296.459L543.411 296.377Z",
    fill: "#404FCE"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M346.051 391.031L330.791 382.23C330.7 382.172 330.594 382.141 330.486 382.141C330.379 382.141 330.273 382.172 330.182 382.23L322.196 386.783L338.716 400.156L346.701 395.543C346.805 395.453 346.885 395.34 346.935 395.212C346.984 395.085 347.002 394.947 346.986 394.811V392.778C346.976 392.435 346.887 392.098 346.725 391.794C346.562 391.491 346.332 391.229 346.051 391.031Z",
    fill: "url(#paint45_linear_1_781)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M338.087 400.114L322.827 391.293C322.545 391.091 322.314 390.826 322.151 390.519C321.989 390.213 321.901 389.872 321.893 389.525V387.493C321.893 386.801 322.319 386.497 322.827 386.781L338.087 395.602C338.373 395.805 338.607 396.073 338.77 396.384C338.932 396.695 339.018 397.04 339.022 397.391V399.423C339.022 400.094 338.615 400.419 338.087 400.114Z",
    fill: "#404FCE"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M335.565 397.798L325.406 391.884C325.218 391.75 325.064 391.574 324.958 391.369C324.852 391.163 324.796 390.936 324.796 390.705V389.811C324.796 389.343 325.061 389.14 325.406 389.343L335.565 395.237C335.757 395.374 335.914 395.554 336.023 395.762C336.132 395.97 336.192 396.201 336.195 396.436V397.31C336.195 397.778 335.911 398.001 335.565 397.798Z",
    fill: "#242993"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M351.941 398.712C351.91 398.069 351.726 397.442 351.404 396.884C351.083 396.325 350.633 395.851 350.092 395.501C349.903 395.366 349.68 395.284 349.448 395.262C349.217 395.241 348.983 395.281 348.772 395.379L343.712 398.286L346.333 402.818L351.393 399.912C351.578 399.774 351.726 399.593 351.822 399.383C351.918 399.173 351.959 398.942 351.941 398.712Z",
    fill: "url(#paint46_linear_1_781)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M346.883 401.66C346.883 402.839 346.07 403.327 345.034 402.737C344.493 402.387 344.044 401.913 343.722 401.355C343.401 400.796 343.216 400.169 343.185 399.526C343.185 398.347 344.018 397.88 345.034 398.469C345.572 398.817 346.019 399.288 346.341 399.843C346.662 400.397 346.848 401.02 346.883 401.66Z",
    fill: "#404FCE"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M346.293 401.334C346.293 402.126 345.744 402.451 345.033 402.045C344.665 401.809 344.359 401.489 344.14 401.11C343.92 400.732 343.795 400.307 343.773 399.87C343.773 399.077 344.342 398.752 345.033 399.138C345.403 399.378 345.71 399.701 345.929 400.083C346.148 400.465 346.273 400.894 346.293 401.334Z",
    fill: "#242993"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M326.036 383.225C326.004 382.582 325.82 381.955 325.498 381.397C325.177 380.838 324.727 380.364 324.187 380.014C323.997 379.879 323.775 379.797 323.543 379.775C323.311 379.754 323.077 379.794 322.866 379.892L317.807 382.798L320.428 387.331L325.487 384.424C325.676 384.29 325.825 384.109 325.922 383.898C326.018 383.688 326.057 383.456 326.036 383.225Z",
    fill: "url(#paint47_linear_1_781)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M320.979 386.13C320.979 387.309 320.146 387.777 319.13 387.187C318.59 386.837 318.14 386.363 317.819 385.805C317.497 385.246 317.313 384.62 317.281 383.976C317.281 382.797 318.114 382.33 319.13 382.919C319.671 383.27 320.12 383.743 320.442 384.302C320.763 384.86 320.948 385.487 320.979 386.13Z",
    fill: "#404FCE"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M320.389 385.785C320.389 386.578 319.82 386.903 319.129 386.497C318.761 386.261 318.455 385.941 318.236 385.562C318.017 385.184 317.891 384.759 317.87 384.322C317.87 383.529 318.439 383.204 319.129 383.59C319.497 383.832 319.802 384.156 320.021 384.538C320.24 384.919 320.366 385.346 320.389 385.785Z",
    fill: "#242993"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M307.262 368.612L292.002 359.791C291.907 359.736 291.798 359.707 291.687 359.707C291.577 359.707 291.468 359.736 291.372 359.791L283.407 364.385L299.906 377.779L307.892 373.165C307.999 373.078 308.083 372.965 308.137 372.838C308.19 372.71 308.21 372.571 308.196 372.433V370.401C308.189 370.051 308.1 369.707 307.938 369.397C307.776 369.087 307.545 368.818 307.262 368.612Z",
    fill: "url(#paint48_linear_1_781)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M299.297 377.696L284.037 368.875C283.751 368.673 283.517 368.405 283.355 368.094C283.192 367.783 283.106 367.438 283.103 367.087V365.054C283.103 364.363 283.509 364.058 284.037 364.343L299.297 373.164C299.577 373.367 299.805 373.632 299.964 373.939C300.122 374.247 300.207 374.586 300.211 374.932V376.965C300.211 377.676 299.845 377.981 299.297 377.696Z",
    fill: "#404FCE"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M296.779 375.359L286.619 369.465C286.428 369.329 286.271 369.149 286.162 368.941C286.052 368.732 285.993 368.501 285.989 368.266V367.392C285.989 366.925 286.274 366.721 286.619 366.925L296.779 372.819C296.968 372.957 297.121 373.137 297.227 373.345C297.333 373.554 297.388 373.784 297.388 374.018V374.892C297.388 375.359 297.124 375.563 296.779 375.359Z",
    fill: "#242993"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M313.134 376.357C313.102 375.713 312.918 375.086 312.596 374.528C312.275 373.97 311.825 373.496 311.285 373.145C311.101 373.006 310.882 372.921 310.652 372.899C310.422 372.878 310.191 372.921 309.984 373.023L304.945 375.93L307.566 380.442L312.605 377.556C312.795 377.424 312.945 377.242 313.038 377.03C313.131 376.819 313.164 376.586 313.134 376.357Z",
    fill: "url(#paint49_linear_1_781)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M308.096 379.241C308.096 380.42 307.263 380.908 306.247 380.318C305.706 379.968 305.257 379.494 304.935 378.936C304.614 378.378 304.429 377.751 304.398 377.107C304.398 375.928 305.21 375.461 306.247 376.05C306.785 376.399 307.232 376.869 307.554 377.424C307.875 377.978 308.061 378.601 308.096 379.241Z",
    fill: "#404FCE"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M307.506 378.896C307.506 379.709 306.937 380.034 306.246 379.627C305.879 379.39 305.574 379.07 305.355 378.692C305.136 378.314 305.01 377.889 304.986 377.453C304.986 376.64 305.535 376.315 306.246 376.721C306.611 376.961 306.914 377.282 307.133 377.659C307.352 378.037 307.479 378.46 307.506 378.896Z",
    fill: "#242993"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M287.229 360.806C287.197 360.163 287.013 359.536 286.692 358.978C286.37 358.419 285.921 357.945 285.38 357.595C285.192 357.456 284.97 357.371 284.737 357.35C284.504 357.328 284.27 357.371 284.059 357.473L279 360.38L281.621 364.892L286.68 362.006C286.872 361.874 287.024 361.693 287.121 361.482C287.218 361.271 287.255 361.037 287.229 360.806Z",
    fill: "url(#paint50_linear_1_781)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M282.167 363.693C282.167 364.872 281.334 365.36 280.318 364.77C279.778 364.42 279.328 363.946 279.006 363.388C278.685 362.829 278.501 362.202 278.469 361.559C278.469 360.38 279.302 359.912 280.318 360.502C280.856 360.85 281.304 361.321 281.625 361.876C281.947 362.43 282.132 363.053 282.167 363.693Z",
    fill: "#404FCE"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M281.557 363.347C281.557 364.16 280.988 364.485 280.297 364.079C279.932 363.841 279.627 363.52 279.408 363.142C279.189 362.764 279.063 362.34 279.038 361.904C279.038 361.091 279.607 360.766 280.297 361.172C280.662 361.412 280.966 361.733 281.184 362.111C281.403 362.488 281.531 362.912 281.557 363.347Z",
    fill: "#242993"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M286.395 324.222L284.322 325.422L273.35 326.438L275.423 325.259L286.395 324.222Z",
    fill: "#7990FC"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M274.935 337.556L273.33 336.641L272.558 338.572L273.533 339.162L274.935 337.556Z",
    fill: "#7990FC"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M266.848 340.38L265.852 340.97L259.33 344.73C258.776 345.091 258.315 345.577 257.983 346.149C257.652 346.721 257.459 347.362 257.42 348.022C257.42 349.242 258.273 349.73 259.33 349.14L263.922 346.478C264.979 345.868 265.852 346.376 265.852 347.596C265.813 348.266 265.618 348.918 265.283 349.5C264.948 350.082 264.482 350.578 263.922 350.949L259.33 353.591C258.776 353.953 258.315 354.439 257.983 355.011C257.652 355.582 257.459 356.224 257.42 356.884C257.42 358.104 258.273 358.591 259.33 358.002L265.852 354.222L266.848 353.652L273.431 349.933V336.681L266.848 340.38Z",
    fill: "#7990FC"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M259.615 350.198L257.928 349.222L259.493 348.145L259.615 350.198Z",
    fill: "#7990FC"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M259.634 359.058L257.947 358.103L260.609 357.554L259.634 359.058Z",
    fill: "#7990FC"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M268.453 341.295L267.437 341.864L260.915 345.645C260.352 345.996 259.884 346.48 259.551 347.054C259.218 347.628 259.03 348.274 259.005 348.938C259.005 350.157 259.858 350.645 260.915 350.035L265.507 347.393C266.563 346.763 267.437 347.271 267.437 348.511C267.397 349.178 267.202 349.828 266.867 350.406C266.532 350.985 266.066 351.477 265.507 351.844L260.915 354.507C260.352 354.858 259.884 355.341 259.551 355.915C259.218 356.489 259.03 357.136 259.005 357.799C259.005 359.019 259.858 359.506 260.915 358.897L267.437 355.137L268.453 354.547L274.935 350.807V337.535L268.453 341.295Z",
    fill: "#2D36AD"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M243.074 207.028H240.758C236.979 197.374 228.566 188.208 215.583 180.606C179.009 159.448 119.576 159.448 82.9407 180.606C70.7493 187.699 62.4999 196.256 58.4564 205.321H55.5101V217.313C54.7786 231.723 63.9222 246.235 82.9407 257.231C119.515 278.369 178.968 278.389 215.603 257.231C233.89 246.642 243.074 232.841 243.074 218.918V207.028Z",
    fill: "url(#paint51_linear_1_781)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M243.074 207.028H240.758C236.979 197.374 228.566 188.208 215.583 180.606C179.009 159.448 119.576 159.448 82.9407 180.606C70.7493 187.699 62.4999 196.256 58.4564 205.321H55.5101V217.313C54.7786 231.723 63.9222 246.235 82.9407 257.231C119.515 278.369 178.968 278.389 215.603 257.231C233.89 246.642 243.074 232.841 243.074 218.918V207.028Z",
    fill: "url(#paint52_linear_1_781)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M243.074 202.395H240.758C236.979 192.741 228.566 183.574 215.583 175.973C179.009 154.814 119.576 154.814 82.9407 175.973C70.7493 183.066 62.4999 191.643 58.4564 200.688H55.5101V212.7C54.7786 227.09 63.9222 241.622 82.9407 252.597C119.515 273.755 178.968 273.755 215.603 252.597C233.89 242.028 243.074 228.207 243.074 214.305V202.395Z",
    fill: "url(#paint53_linear_1_781)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M240.756 202.375L240.33 201.358V193.432H235.413V192.863C234.129 191.143 232.738 189.507 231.247 187.964V193.432H228.423V185.302C227.122 184.123 225.72 182.964 224.237 181.826V193.432H221.433V179.712C220.079 178.777 218.677 177.863 217.227 176.968V193.432H214.504V175.343C213.143 174.57 211.741 173.838 210.298 173.127V193.452H207.515V171.847C206.133 171.217 204.731 170.607 203.288 170.017V193.432H200.525V174.428H196.217V193.432H193.474V179.651H189.207V193.432H186.464V184.875H182.197V193.432H179.475V190.078H175.187V193.432H123.394V190.078H119.127V193.432H116.384V184.875H112.117V193.432H109.374V179.651H105.128V193.432H102.385V174.428H98.1379V193.432H95.3745V169.997C93.9318 170.586 92.5298 171.196 91.1278 171.826V193.432H88.3645V173.107C86.9218 173.818 85.5198 174.55 84.1381 175.322V193.432H81.3544V176.948C79.8914 177.842 78.4894 178.737 77.1484 179.672V193.432H74.3037V181.704C72.8204 182.842 71.4184 184.021 70.118 185.2V193.432H67.2937V187.924C65.792 189.462 64.3938 191.099 63.108 192.822V193.432H58.1908V200.708H56.1589V220.85C56.9707 224.612 58.3768 228.221 60.3243 231.541V218.96H63.1487V235.809C64.4393 237.528 65.8374 239.164 67.3343 240.707V218.96H70.2399V243.349C71.5404 244.528 72.9424 245.687 74.4256 246.825V218.98H77.2297V248.959C78.5843 249.894 79.9863 250.809 81.4357 251.703V218.98H84.2194V253.309C85.6011 254.081 87.003 254.833 88.4457 255.544V218.96H91.2091V256.845C92.6111 257.496 94.0131 258.105 95.4557 258.674V218.98H98.2191V259.752C99.6008 260.28 101.023 260.788 102.466 261.256V218.98H105.209V262.15L109.455 263.39V218.98H112.199V264.101L116.466 265.077V218.98H119.209V265.727L123.476 266.499V218.98H126.198V266.845L130.486 267.414V218.98H133.188V267.76C134.631 267.902 136.053 268.024 137.496 268.125V218.98H140.178V268.247L144.506 268.43V218.98H147.188V268.491H151.516V218.98H154.177V268.43L158.505 268.247V218.98H161.188V268.065C162.63 267.963 164.073 267.841 165.495 267.699V218.919H168.197V267.333C169.64 267.17 171.083 266.987 172.505 266.764V218.98H175.208V266.418L179.495 265.646V218.899H182.218V264.995C183.66 264.691 185.083 264.365 186.485 264V218.98H189.228V263.369C190.67 262.983 192.072 262.577 193.495 262.13V218.98H196.217V261.256C197.66 260.768 199.062 260.28 200.464 259.752V218.98H203.227V258.654C204.67 258.085 206.072 257.475 207.454 256.845V218.98H210.237V255.565C211.68 254.853 213.082 254.101 214.443 253.329V218.98H217.247V251.683C218.71 250.788 220.112 249.874 221.453 248.939V218.98H224.257V246.906C225.741 245.768 227.143 244.61 228.443 243.41V219.021H231.267V240.728C232.763 239.189 234.154 237.553 235.433 235.829V219.021H238.278V231.541C240.232 228.188 241.638 224.545 242.443 220.748V202.456L240.756 202.375Z",
    fill: "url(#paint54_linear_1_781)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M149.262 256.56C201.062 256.56 243.054 232.309 243.054 202.394C243.054 172.479 201.062 148.228 149.262 148.228C97.4617 148.228 55.4695 172.479 55.4695 202.394C55.4695 232.309 97.4617 256.56 149.262 256.56Z",
    fill: "url(#paint55_linear_1_781)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M0.894038 202.192L0 201.664L144.711 118.108L145.605 118.616L0.894038 202.192Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M3.45306 203.655L2.55902 203.147L147.27 119.571L148.144 120.079L3.45306 203.655Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M5.99218 205.118L5.09814 204.61L149.81 121.034L150.704 121.542L5.99218 205.118Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M8.53508 206.602L7.66138 206.093L152.373 122.518L153.247 123.026L8.53508 206.602Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M11.0945 208.065L10.2004 207.557L154.912 123.981L155.806 124.489L11.0945 208.065Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M13.6343 209.549L12.7605 209.041L157.472 125.465L158.346 125.973L13.6343 209.549Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M16.1936 211.012L15.2996 210.504L160.011 126.928L160.905 127.436L16.1936 211.012Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M18.7333 212.496L17.8596 211.967L162.571 128.412L163.445 128.92L18.7333 212.496Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M21.2927 213.96L20.3987 213.452L165.11 129.876L166.004 130.384L21.2927 213.96Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M23.8324 215.422L22.9587 214.914L167.65 131.338L168.544 131.866L23.8324 215.422Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M26.3939 216.906L25.4999 216.398L170.211 132.822L171.105 133.33L26.3939 216.906Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M28.9359 218.371L28.0621 217.863L172.753 134.287L173.647 134.815L28.9359 218.371Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M31.4952 219.853L30.6012 219.345L175.313 135.77L176.186 136.278L31.4952 219.853Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M34.0339 221.318L33.1602 220.81L177.851 137.234L178.745 137.742L34.0339 221.318Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M36.5933 222.802L35.6992 222.274L180.411 138.719L181.284 139.227L36.5933 222.802Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M39.1323 224.263L38.2383 223.755L182.95 140.179L183.844 140.688L39.1323 224.263Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M41.6946 225.747L40.8005 225.219L185.512 141.663L186.386 142.171L41.6946 225.747Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M44.2336 227.212L43.3396 226.704L188.051 143.128L188.945 143.636L44.2336 227.212Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M46.7745 228.674L45.9008 228.166L190.612 144.59L191.486 145.119L46.7745 228.674Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M49.3339 230.158L48.4398 229.65L193.151 146.074L194.045 146.583L49.3339 230.158Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M51.8736 231.623L50.9999 231.115L195.711 147.539L196.585 148.067L51.8736 231.623Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M54.433 233.105L53.5389 232.597L198.25 149.021L199.144 149.53L54.433 233.105Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M56.9737 234.569L56.1 234.061L200.811 150.485L201.685 150.993L56.9737 234.569Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M59.5331 236.053L58.639 235.525L203.35 151.969L204.245 152.477L59.5331 236.053Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M62.0751 237.515L61.2013 237.007L205.913 153.431L206.786 153.94L62.0751 237.515Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M64.6344 238.98L63.7404 238.472L208.452 154.896L209.346 155.424L64.6344 238.98Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M67.1731 240.464L66.2994 239.955L210.991 156.38L211.885 156.888L67.1731 240.464Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M69.7325 241.926L68.8385 241.418L213.55 157.842L214.444 158.371L69.7325 241.926Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M72.2753 243.41L71.4016 242.902L216.113 159.326L216.987 159.834L72.2753 243.41Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M74.8347 244.873L73.9407 244.365L218.652 160.789L219.546 161.297L74.8347 244.873Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M77.3725 246.357L76.4988 245.829L221.19 162.273L222.084 162.781L77.3725 246.357Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M79.936 247.821L79.042 247.313L223.753 163.737L224.647 164.245L79.936 247.821Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M82.4751 249.305L81.5811 248.777L226.292 165.221L227.187 165.729L82.4751 249.305Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M85.0342 250.767L84.1401 250.259L228.852 166.683L229.746 167.191L85.0342 250.767Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M87.5739 252.252L86.7002 251.724L231.391 168.148L232.285 168.676L87.5739 252.252Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M90.1354 253.716L89.2413 253.208L233.953 169.632L234.826 170.14L90.1354 253.716Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M92.6744 255.177L91.7804 254.669L236.492 171.093L237.386 171.622L92.6744 255.177Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M95.2356 256.661L94.3416 256.153L239.053 172.578L239.927 173.086L95.2356 256.661Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M97.7747 258.126L96.8806 257.618L241.592 174.042L242.486 174.57L97.7747 258.126Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M100.335 259.608L99.4407 259.1L244.152 175.524L245.026 176.032L100.335 259.608Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M102.874 261.073L101.98 260.565L246.691 176.989L247.585 177.497L102.874 261.073Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M105.415 262.557L104.541 262.028L249.252 178.473L250.126 178.981L105.415 262.557Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M107.974 264.02L107.08 263.512L251.791 179.936L252.685 180.444L107.974 264.02Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M110.515 265.504L109.641 264.975L254.352 181.42L255.226 181.928L110.515 265.504Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M113.074 266.967L112.18 266.459L256.892 182.883L257.786 183.392L113.074 266.967Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M115.614 268.429L114.74 267.921L259.452 184.345L260.325 184.874L115.614 268.429Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M118.173 269.914L117.279 269.406L261.991 185.83L262.885 186.338L118.173 269.914Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M120.716 271.378L119.843 270.87L264.554 187.294L265.428 187.822L120.716 271.378Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M123.276 272.861L122.382 272.332L267.093 188.777L267.987 189.285L123.276 272.861Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M125.815 274.324L124.942 273.816L269.633 190.24L270.527 190.748L125.815 274.324Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M128.375 275.809L127.481 275.28L272.192 191.725L273.066 192.233L128.375 275.809Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M130.916 277.271L130.042 276.763L274.733 193.187L275.627 193.695L130.916 277.271Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M133.475 278.735L132.581 278.227L277.292 194.651L278.166 195.179L133.475 278.735Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M136.014 280.219L135.14 279.711L279.831 196.135L280.725 196.643L136.014 280.219Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M138.575 281.682L137.681 281.173L282.393 197.598L283.266 198.126L138.575 281.682Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M141.114 283.165L140.22 282.657L284.932 199.081L285.826 199.589L141.114 283.165Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M143.655 284.629L142.781 284.121L287.493 200.545L288.366 201.053L143.655 284.629Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M146.214 286.113L145.32 285.584L290.032 202.029L290.926 202.537L146.214 286.113Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M148.754 287.575L147.88 287.067L292.592 203.491L293.465 203.999L148.754 287.575Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M151.313 289.059L150.419 288.531L295.131 204.975L296.025 205.483L151.313 289.059Z",
    fill: "#97A6FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M153.854 290.523L152.981 290.015L297.692 206.439L298.566 206.947L153.854 290.523Z",
    fill: "#97A6FD"
  }))), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M149.262 250.362C195.137 250.362 232.326 228.886 232.326 202.395C232.326 175.904 195.137 154.428 149.262 154.428C103.387 154.428 66.1985 175.904 66.1985 202.395C66.1985 228.886 103.387 250.362 149.262 250.362Z",
    fill: "url(#paint56_linear_1_781)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M149.262 300.767C201.062 300.767 243.054 276.516 243.054 246.601C243.054 216.686 201.062 192.435 149.262 192.435C97.4617 192.435 55.4695 216.686 55.4695 246.601C55.4695 276.516 97.4617 300.767 149.262 300.767Z",
    fill: "#0F054C"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M149.262 279.04C201.062 279.04 243.054 254.789 243.054 224.874C243.054 194.959 201.062 170.708 149.262 170.708C97.4617 170.708 55.4695 194.959 55.4695 224.874C55.4695 254.789 97.4617 279.04 149.262 279.04Z",
    fill: "url(#paint57_linear_1_781)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.305 148.228C128.052 148.228 106.798 152.293 89.4862 160.647L61.5071 221.499C67.0556 229.483 74.3974 236.054 82.9435 240.686C89.2334 244.265 95.8713 247.193 102.754 249.426L149.305 148.228Z",
    fill: "#97A6FD"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M175.576 150.383L127.441 255.076C139.076 256.659 150.849 256.972 162.552 256.011L206.867 159.651C196.875 155.239 186.359 152.124 175.576 150.383Z",
    fill: "#97A6FD"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M243.074 207.028H240.758C236.979 197.374 228.566 188.208 215.583 180.606C179.009 159.448 119.576 159.448 82.9407 180.606C70.7493 187.699 62.4999 196.256 58.4564 205.321H55.5101V217.313C54.7786 231.723 63.9222 246.235 82.9407 257.231C119.515 278.369 178.968 278.389 215.603 257.231C233.89 246.642 243.074 232.841 243.074 218.918V207.028Z",
    fill: "url(#paint58_linear_1_781)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5613 171.706C123.072 152.966 175.576 152.966 208.025 171.706C223.528 180.649 231.615 192.274 232.306 204.002C233.038 191.197 224.951 178.25 208.025 168.474C175.515 149.734 122.99 149.734 90.5613 168.474C73.6153 178.25 65.5283 191.197 66.2801 204.002C66.9303 192.274 75.0173 180.649 90.5613 171.706Z",
    fill: "url(#paint59_linear_1_781)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M182.016 183.696L101.024 173.676L118.377 220.443L171.125 214.142L182.016 183.696Z",
    fill: "url(#paint60_linear_1_781)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M118.376 220.443L140.544 186.277L171.124 214.142L118.376 220.443Z",
    fill: "#0F1C75"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M182.016 183.697L140.545 186.278L171.125 214.143L182.016 183.697Z",
    fill: "#0F1C75"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M126.039 224.854L200.487 231.114L189.657 188.107L178.746 211.724L126.039 224.854Z",
    fill: "url(#paint61_linear_1_781)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M178.745 211.724L200.487 231.114L189.657 188.107L178.745 211.724Z",
    fill: "#0F1C75"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_781",
    transform: "scale(0.000884956 0.0022779)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_781",
    transform: "scale(0.00121212 0.00263852)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_1_781",
    transform: "scale(0.00231481 0.00384615)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_1_781",
    transform: "scale(0.00657895)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_781",
    x1: 347.167,
    y1: 325.544,
    x2: 348.997,
    y2: 345.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_781",
    x1: 11374.6,
    y1: 5535.82,
    x2: 11607.7,
    y2: 5616.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_781",
    x1: 13772.4,
    y1: 4615.88,
    x2: 14022.3,
    y2: 4417.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_781",
    x1: 19521.3,
    y1: 2212.04,
    x2: 19524.4,
    y2: 2161.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_781",
    x1: 47887.1,
    y1: 13302.8,
    x2: 53573.9,
    y2: 13302.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_781",
    x1: 8608.75,
    y1: 2802.63,
    x2: 8997.7,
    y2: 2802.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_781",
    x1: 117743,
    y1: 29479,
    x2: 135717,
    y2: 47947.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_781",
    x1: 96375.6,
    y1: 33088.4,
    x2: 147934,
    y2: -22756.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_781",
    x1: 148415,
    y1: 29931.8,
    x2: 162389,
    y2: 58324.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_781",
    x1: 119285,
    y1: 32644.7,
    x2: 174836,
    y2: 3751.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_781",
    x1: 115499,
    y1: 27306.7,
    x2: 131210,
    y2: 41094.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_781",
    x1: 117703,
    y1: 31603.4,
    x2: 123475,
    y2: 46610.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_781",
    x1: 41786,
    y1: 7486.82,
    x2: 45584.2,
    y2: 7486.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_781",
    x1: 12778.9,
    y1: 6443.94,
    x2: 12542,
    y2: 6524.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_781",
    x1: 17683.2,
    y1: 5185.98,
    x2: 17570.4,
    y2: 5390.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_781",
    x1: 354.465,
    y1: 306.439,
    x2: 346.8,
    y2: 329.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#97A6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#97A6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#97A6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#97A6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#97A6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_781",
    x1: 10956.7,
    y1: 6227.06,
    x2: 10747,
    y2: 6123.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_781",
    x1: 16484.6,
    y1: 4985.92,
    x2: 16395.8,
    y2: 4772.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_781",
    x1: 18771.5,
    y1: 2419.72,
    x2: 18768.2,
    y2: 2368.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_781",
    x1: 15866.6,
    y1: 4511.95,
    x2: 15875.6,
    y2: 4683.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_781",
    x1: 10713.7,
    y1: 5086.3,
    x2: 10916,
    y2: 5155.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_781",
    x1: 12925.1,
    y1: 4238.7,
    x2: 13141.9,
    y2: 4067.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_781",
    x1: 18323,
    y1: 2044.99,
    x2: 18325.7,
    y2: 2001.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_781",
    x1: 44956.9,
    y1: 6757.58,
    x2: 48753,
    y2: 6757.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_781",
    x1: 13749.8,
    y1: 5819.46,
    x2: 13512.8,
    y2: 5899.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_781",
    x1: 19003.4,
    y1: 4677.06,
    x2: 18890.8,
    y2: 4881.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_781",
    x1: 19406.5,
    y1: 4266.08,
    x2: 19362.4,
    y2: 4505.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_781",
    x1: 11784.5,
    y1: 5625.64,
    x2: 11574.8,
    y2: 5522.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_781",
    x1: 17696,
    y1: 4504.19,
    x2: 17607,
    y2: 4290.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_781",
    x1: 20097.2,
    y1: 2167.61,
    x2: 20093.9,
    y2: 2116.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_781",
    x1: 17078,
    y1: 4084.76,
    x2: 17086.9,
    y2: 4256.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_781",
    x1: 11541.4,
    y1: 4620.67,
    x2: 11743.8,
    y2: 4690.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_781",
    x1: 13950.4,
    y1: 3858.16,
    x2: 14168.1,
    y2: 3686.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1_781",
    x1: 19631.6,
    y1: 1850.47,
    x2: 19634.3,
    y2: 1806.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1_781",
    x1: 48150,
    y1: 6033.61,
    x2: 51946,
    y2: 6033.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1_781",
    x1: 14720.6,
    y1: 5194.66,
    x2: 14483.6,
    y2: 5275.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1_781",
    x1: 20365.9,
    y1: 4180.46,
    x2: 20253.4,
    y2: 4385.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1_781",
    x1: 20812.9,
    y1: 3813.43,
    x2: 20768.9,
    y2: 4052.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#97A6FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1_781",
    x1: 12612.2,
    y1: 5024.34,
    x2: 12402.5,
    y2: 4921.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1_781",
    x1: 18907.3,
    y1: 4029.88,
    x2: 18818.3,
    y2: 3815.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1_781",
    x1: 21508.6,
    y1: 1948.49,
    x2: 21505.3,
    y2: 1897.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1_781",
    x1: 18289.2,
    y1: 3666,
    x2: 18298.2,
    y2: 3837.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1_781",
    x1: 12369.3,
    y1: 4135.13,
    x2: 12571.5,
    y2: 4204.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3DE6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1_781",
    x1: 14868,
    y1: 3457.9,
    x2: 15084.9,
    y2: 3286.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1_781",
    x1: 21005.8,
    y1: 1651.14,
    x2: 21008.5,
    y2: 1607.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#30A2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#266CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1E4596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1A2D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1_781",
    x1: 11926.3,
    y1: 5124.96,
    x2: 12228.8,
    y2: 5124.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1_781",
    x1: 4284.02,
    y1: 2415.58,
    x2: 4317.37,
    y2: 2415.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1_781",
    x1: 4153.98,
    y1: 2342.24,
    x2: 4187.33,
    y2: 2342.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1_781",
    x1: 11413.4,
    y1: 4918.17,
    x2: 11715.8,
    y2: 4918.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1_781",
    x1: 4072.59,
    y1: 2306.38,
    x2: 4105.72,
    y2: 2306.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1_781",
    x1: 3958.88,
    y1: 2232.97,
    x2: 3992.24,
    y2: 2232.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1_781",
    x1: 41.3072,
    y1: 218.979,
    x2: 227.043,
    y2: 218.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#495FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#5489FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1_781",
    x1: 41.3072,
    y1: 218.979,
    x2: 227.043,
    y2: 218.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#495FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#5489FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1_781",
    x1: 61920,
    y1: 19263.2,
    x2: 79068.9,
    y2: 19263.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#411D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3AC5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#349BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2F78BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B5BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2845A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#263599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#242C94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#242993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1_781",
    x1: 62846.9,
    y1: 17771.9,
    x2: 79923.5,
    y2: 17771.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#7366C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7E7AD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6368C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#4EB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#5489FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1_781",
    x1: 101482,
    y1: -27514.7,
    x2: 106645,
    y2: -19127.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7366C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#40F4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3AC5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#349BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2F78BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B5BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2845A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#263599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#242C94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#242993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1_781",
    x1: 134.633,
    y1: 129.185,
    x2: 181.067,
    y2: 361.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#40F4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3AC5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#349BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2F78BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B5BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2845A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#263599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#242C94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#242993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1_781",
    x1: 100749,
    y1: -25862.9,
    x2: 105911,
    y2: -17475.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#654DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#40F4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3AC5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#349BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2F78BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B5BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2845A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#263599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#242C94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#242993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1_781",
    x1: 41.3072,
    y1: 218.979,
    x2: 227.043,
    y2: 218.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#654DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#654DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#654DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#654DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#654DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#654DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654DB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1_781",
    x1: 66.2192,
    y1: 179.205,
    x2: 232.326,
    y2: 179.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1_781",
    x1: 120025,
    y1: -65573.9,
    x2: 121424,
    y2: -63348.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7AD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#40F4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3AC5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#349BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2F78BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B5BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2845A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#263599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#242C94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#242993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1_781",
    x1: 111068,
    y1: -59648.5,
    x2: 111806,
    y2: -58626.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B5BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2845A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#263599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#242C94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#2B237C"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_781",
    width: 1130,
    height: 439,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_781",
    width: 825,
    height: 379,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_1_781",
    width: 432,
    height: 260,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_1_781",
    width: 152,
    height: 152,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrations);
export default __webpack_public_path__ + "static/media/Illustrations.e0501cbfaa91e38bdb2f2512c84f1d43.svg";
export { ForwardRef as ReactComponent };